import * as i1$2 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1$1 from '@angular/common/http';
import { HttpHeaders, HttpParams, HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Inject, InjectionToken, Component, Input, EventEmitter, Output, Pipe, ChangeDetectionStrategy, ViewChild, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i2 from '@angular/forms';
import { FormGroup, Validators, ControlContainer, NgForm, FormControl, FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i5 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i3 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { isNull } from 'common-utils/dist/typescript-utils';
import * as i1 from 'ngx-shared-services';
import { CookieService as CookieService$1 } from 'ngx-shared-services';
import { BehaviorSubject, Subject } from 'rxjs';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';
import * as convertKeys from 'convert-keys';
import * as i6 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i7 from 'enel-tree/dist/enel-tree';
import { TreeModule } from 'enel-tree/dist/enel-tree';
import * as i8 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i8$2 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import * as i9$1 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i5$1 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i6$1 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i7$1 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i8$1 from '@angular/material/core';
import * as i9 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';

class CookieService {
    constructor(ngxCookieService) {
        this.ngxCookieService = ngxCookieService;
    }
    getCookie(cookieName) {
        return this.ngxCookieService.getCookie(cookieName);
    }
    setCookie(cookieName, cookieValue) {
        const ms = Date.now() + 90 * 86400000;
        const exp = new Date(ms).toDateString();
        const host = document.location.hostname;
        const regex = /.enelx.*/;
        const domain = host.match(regex);
        this.ngxCookieService.setCookie(cookieName, cookieValue, {
            'expires': exp,
            'path': '/',
            'max-age': 7200,
            'domain': domain ? domain[0] : '.enelx.net',
        });
    }
    deleteCookie(cookieName) {
        const host = document.location.hostname;
        const regex = /.enelx.*/;
        const domain = host.match(regex);
        this.ngxCookieService.setCookie(cookieName, '', {
            'expires': '0',
            'path': '/',
            'max-age': 7200,
            'domain': domain ? domain[0] : '.enelx.net',
        });
    }
    static { this.ɵfac = function CookieService_Factory(t) { return new (t || CookieService)(i0.ɵɵinject(i1.CookieService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CookieService, factory: CookieService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CookieService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.CookieService }]; }, null); })();

const PREFERRED_ORG_ID_COOKIE = 'preferred-org-id';
const PREFERRED_ADMIN_GROUP_ID_COOKIE = 'preferred-admin-group-id';
class ContextSelectorService {
    constructor(cookieService) {
        this.cookieService = cookieService;
        this.primaryOrgId = '';
        this.isMultiSelect = false;
        this.maxSelections = 5;
        this.isMultiLevel = false;
        this.isSingleNode = false;
        this.disabledNodeValues = [];
        this.disabledNodeDefinitions = { ['space_type']: this.disabledNodeValues };
        this._contextList$ = new BehaviorSubject([]);
        this.currentContext$ = new BehaviorSubject([
            {
                id: '',
                label: 'Select an Organization',
                space_type: 'Organization',
            },
        ]);
        this.forceHide$ = new BehaviorSubject(false);
        this.showContextSelector$ = new BehaviorSubject(false);
        this.contextList$ = this._contextList$.pipe(distinctUntilChanged(), shareReplay(1));
    }
    /**
     * Sets the list of context to which a user has access.
     * This is used in global-nav to populate the list in the modal.
     * @param list Array
     * @param forceDefaultContextId
     */
    setContextList(list, forceDefaultContextId) {
        this._contextList$.next(list);
        this.setListProperties();
        let defaultContext;
        // I have a heirarchy and only one top level node
        if (this.isMultiLevel && list.length === 1) {
            this.isSingleNode = true;
        }
        if (list && list.length > 0) {
            if (!this.isMultiLevel && list.length === 1) {
                this.showContextSelector$.next(false);
            }
            else {
                this.showContextSelector$.next(true);
            }
            if (forceDefaultContextId && this.isContextValid(forceDefaultContextId)) {
                defaultContext = this.isContextValid(forceDefaultContextId);
            }
            else {
                defaultContext = this.getContext();
            }
        }
        if (defaultContext) {
            this.setContext([defaultContext]);
        }
        else {
            console.warn('No valid selections found');
        }
    }
    setPrimaryOrgId(orgId) {
        this.primaryOrgId = orgId;
    }
    selectContexts(contextIds, isAdminGroup) {
        const validContexts = [];
        if (contextIds && contextIds.length) {
            contextIds.forEach(contextId => {
                if (this.isContextValid(contextId)) {
                    validContexts.push(this.isContextValid(contextId));
                }
            });
            let spaceType = 'Organization';
            if (isAdminGroup) {
                this.cookieService.deleteCookie(PREFERRED_ORG_ID_COOKIE);
                this.cookieService.setCookie(PREFERRED_ADMIN_GROUP_ID_COOKIE, contextIds[0]);
                spaceType = 'AdminGroup';
            }
            else {
                this.cookieService.deleteCookie(PREFERRED_ADMIN_GROUP_ID_COOKIE);
                this.cookieService.setCookie(PREFERRED_ORG_ID_COOKIE, contextIds[0]);
            }
            if (validContexts && validContexts.length) {
                this.setContext(validContexts, spaceType);
            }
        }
    }
    forceHideContextSelector(hide) {
        this.forceHide$.next(hide);
    }
    setMultiSelect(isMultiSelect) {
        this.isMultiSelect = isMultiSelect;
    }
    setMaxSelections(maxSelections) {
        this.maxSelections = maxSelections;
    }
    setDisabledNodeValues(values) {
        this.disabledNodeValues = values;
        this.disabledNodeDefinitions = { ['space_type']: values };
    }
    setContext(context, spaceType = 'Organization') {
        // context.space_type = spaceType;
        this.currentContext$.next(context);
    }
    isContextValid(contextId) {
        let foundContext;
        for (const parent of this._contextList$.value) {
            if (parent.id === contextId) {
                foundContext = parent;
            }
            if (!foundContext && parent.children) {
                for (const child of parent.children) {
                    if (child.id === contextId) {
                        foundContext = child;
                    }
                }
            }
        }
        return foundContext
            ? { id: foundContext.id, label: foundContext.display_label, space_type: foundContext.space_type }
            : null;
    }
    setListProperties() {
        for (const space of this._contextList$.value) {
            if (space.children && space.children.length > 0) {
                this.isMultiLevel = true;
                return;
            }
        }
    }
    isMultiOrg() {
        const adminGroups = this._contextList$.value?.filter(space => {
            return space.space_type === 'AdminGroup' && space.children && space.children.length > 0;
        });
    }
    getContext() {
        let defaultContext = this.isContextValid(this._contextList$.value[0].id);
        if (this.disabledNodeValues && this.isMultiLevel) {
            const parent = this._contextList$.value[0];
            if (this.disabledNodeValues.some((disabledValue) => disabledValue == parent?.space_type)) {
                let firstChildId = '';
                if (parent.children) {
                    firstChildId = parent.children[0]?.id;
                }
                defaultContext = this.isContextValid(firstChildId);
            }
        }
        return (this.isContextValid(this.cookieService.getCookie(PREFERRED_ADMIN_GROUP_ID_COOKIE)) ||
            this.isContextValid(this.cookieService.getCookie(PREFERRED_ORG_ID_COOKIE)) ||
            this.isContextValid(this.primaryOrgId) ||
            this.isContextValid(defaultContext?.id));
    }
    static { this.ɵfac = function ContextSelectorService_Factory(t) { return new (t || ContextSelectorService)(i0.ɵɵinject(CookieService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ContextSelectorService, factory: ContextSelectorService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContextSelectorService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CookieService }]; }, null); })();

class ApiService {
    constructor(http, cookieService, document) {
        this.http = http;
        this.cookieService = cookieService;
        this.document = document;
        this.headers = new HttpHeaders();
        this.loginDomain = '';
        this.navUrl$ = new BehaviorSubject('');
        this.navUrl$.subscribe((navUrl) => {
            const enocSession = this.cookieService.getCookie('enoc_session');
            this.loginDomain = navUrl;
            if (enocSession) {
                this.headers = this.headers
                    .set('Authorization', enocSession)
                    .set('enoc_session', enocSession);
            }
            else {
                this.redirectToLogin();
            }
        });
    }
    /**
     * Common handler for get requests to API
     * @param url
     * @param params (optional)
     * @returns Promise<any>
     */
    async get(url, params, fullResponse) {
        return await this.request('get', url, null, params, fullResponse);
    }
    /**
     * Common handler for post requests to API
     * @param url
     * @param body
     * @param params (optional)
     * @returns Promise<any>
     */
    async post(url, body, params) {
        return await this.request('post', url, body, params);
    }
    /**
     * Common handler for delete requests to API
     * @param url
     * @param params (optional)
     * @returns Promise<any>
     */
    async delete(url, params) {
        return await this.request('delete', url, null, params);
    }
    /**
     * Common handler for put requests to API
     * @param url
     * @param body
     * @param params (optional)
     * @returns Promise<any>
     */
    async put(url, body, params) {
        return await this.request('put', url, body, params);
    }
    async redirectToLogin() {
        if (this.loginDomain) {
            const url = this.document.location.pathname;
            const pathBrand = url.split('/')[1];
            const { supportedBrands } = window;
            let prezEndpoint = `${this.loginDomain}/links/login-page`;
            if (supportedBrands && supportedBrands.includes(pathBrand)) {
                prezEndpoint = `${this.loginDomain}/links/login-page?brand=${pathBrand}`;
            }
            console.log('redirectToLogin - redirecting to endpoint: ', prezEndpoint);
            if (prezEndpoint) {
                try {
                    const links = await this.get(prezEndpoint);
                    console.log('found links for user: ', links);
                    const loginPage = links.LOGIN_PAGE ? links.LOGIN_PAGE.reference : links.reference;
                    this.document.location = loginPage + '&goto=' + this.document.location;
                }
                catch (err) {
                    console.error('redirect threw error', err);
                    throw err;
                }
            }
            else {
                console.log('tried to redirect with a null endpoint');
            }
        }
    }
    async request(method, url, body, params, fullResponse) {
        let httpParams = new HttpParams();
        if (params) {
            Object.keys(params).forEach((key) => {
                httpParams = httpParams.set(key, params[key]);
            });
        }
        const opts = {
            params: httpParams,
            headers: this.headers,
        };
        let response;
        if (method === 'put' || method === 'post' || method === 'patch') {
            // @ts-ignore
            response = this.http[method](url, body, opts);
        }
        else if (method === 'get' || method === 'delete' || method === 'options') {
            // @ts-ignore
            response = this.http[method](url, opts);
        }
        else {
            response = {};
        }
        const isSuccess = (code) => code >= 200 && code < 300;
        try {
            const res = await response.toPromise();
            if (res && res.data && isSuccess(res.code)) {
                if (fullResponse) {
                    return res;
                }
                else {
                    return res.data;
                }
            }
            else {
                console.log('Error: API Service - unexpected response format');
                throw res;
            }
        }
        catch (err) {
            if (err.status === 401) {
                return this.redirectToLogin();
            }
            console.log('Error: API Service - ' + JSON.stringify(err.error));
            throw err;
        }
    }
    static { this.ɵfac = function ApiService_Factory(t) { return new (t || ApiService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i1.CookieService), i0.ɵɵinject(DOCUMENT)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiService, factory: ApiService.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiService, [{
        type: Injectable
    }], function () { return [{ type: i1$1.HttpClient }, { type: i1.CookieService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

const PAGE_SIZE = 1000;
class GlobalNavService extends ApiService {
    constructor(http, cookieService, document) {
        super(http, cookieService, document);
        this.cookieServ = cookieService;
        this.userData$ = new BehaviorSubject(null);
        this.metaData$ = new BehaviorSubject(null);
        this.serviceAccounts$ = new BehaviorSubject(null);
        this.pendingUtilities$ = new BehaviorSubject(null);
        this.userRolesList$ = new BehaviorSubject(null);
    }
    async getUser() {
        try {
            const endpoint = `${this.navUrl$.getValue()}/user`;
            const user = await this.get(endpoint);
            this.userData$.next(user);
        }
        catch (err) {
            throw err;
        }
    }
    async getUserRoles(userId) {
        try {
            const endpoint = `${this.navUrl$.getValue()}/user/${userId}/roles`;
            const user = await this.get(endpoint);
            this.userRolesList$.next(user);
        }
        catch (err) {
            throw err;
        }
    }
    async getPendingUtilities(serviceAccounts) {
        this.pendingUtilities$.next([]);
        const utilities = [];
        let accountsFiltered = [];
        let accountLabel = '';
        let utilitiesFiltered = [];
        const locale = this.cookieServ.getRawI18nLocale() || 'EN_US';
        const [before, after] = locale.replace('-', '_').split('_');
        const userLocale = before + '_' + after.toUpperCase();
        serviceAccounts.forEach((account) => {
            // If an account is found that is unauthorized
            if (account.loaStatus === 'UNAUTHORIZED') {
                // If that utility doesn't have a notification for it yet
                if (!utilities.some((utility) => utility.name === account.utilityName)) {
                    //Subscribtion to user metaData object to get the list of utilities coming from RefService
                    this.metaData$.subscribe((data) => {
                        if (data) {
                            accountsFiltered = data.utilities.filter((accounts) => accounts.name == account.utilityName);
                            //from the service account I retrieve the label
                            accountLabel = accountsFiltered?.length > 0 ? accountsFiltered[0].display_labels[userLocale] : '';
                            const newUtility = {
                                label: accountLabel,
                                name: account.utilityName,
                            };
                            if (!utilitiesFiltered.find((element) => element.name === newUtility.name)) {
                                utilitiesFiltered.push(newUtility);
                                utilities.push(newUtility);
                                this.pendingUtilities$.next(utilities);
                            }
                        }
                    });
                }
            }
        });
    }
    async getServiceAccounts() {
        const firstPageResponse = await this.get(`${this.navUrl$.getValue()}/service-accounts`, { page: 1, per_page: PAGE_SIZE }, true);
        const numberOfPages = Math.ceil(firstPageResponse.data.meta?.total / PAGE_SIZE);
        const allPages = [];
        for (let page = 2; page <= numberOfPages; page++) {
            allPages.push(this.get(`${this.navUrl$.getValue()}/service-accounts`, { page, per_page: PAGE_SIZE }, true));
        }
        let result = [firstPageResponse];
        const allPagesResponses = await Promise.all(allPages);
        result = [...result, ...allPagesResponses];
        const allDataServiceAccounts = result.reduce((data, response) => {
            return [...data, ...response.data.service_accounts];
        }, []);
        this.serviceAccounts$.next(convertKeys.toCamel(allDataServiceAccounts));
    }
    async getMetadata(userId) {
        try {
            const locale = this.cookieServ.getCookie('locale');
            const endpoint = `${this.navUrl$.getValue()}/user/${userId}/metadata?locale=${locale.replace('-', '_')}`;
            const metadata = await this.get(endpoint);
            this.metaData$.next(metadata);
        }
        catch (err) {
            throw err;
        }
    }
    async submitUserData(userData) {
        const endpoint = `${this.navUrl$.getValue()}/user/${userData.user_id}`;
        return await this.put(endpoint, userData);
    }
    async getMenu(userId, locale) {
        const endpoint = `${this.navUrl$.getValue()}/user/${userId}/menu?locale=${locale}`;
        return await this.get(endpoint);
    }
    refetchUser() {
        this.getUser();
    }
    setNavUrl(navUrl) {
        this.navUrl$.next(navUrl || '');
    }
    static { this.ɵfac = function GlobalNavService_Factory(t) { return new (t || GlobalNavService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i1.CookieService), i0.ɵɵinject(DOCUMENT)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GlobalNavService, factory: GlobalNavService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalNavService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$1.HttpClient }, { type: i1.CookieService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

function ContextSelectorComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function ContextSelectorComponent_button_9_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.submitSelection(false)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r0.contextSelectorService.isMultiSelect ? i0.ɵɵpipeBind1(1, 4, ctx_r0.namespace + "GlobalNav.done_disable_tooltip_multiple") : i0.ɵɵpipeBind1(2, 6, ctx_r0.namespace + "GlobalNav.done_disable_tooltip_no_multiple"));
    i0.ɵɵproperty("disabled", !ctx_r0.tempSelected.length)("matTooltipDisabled", ctx_r0.tempSelected.length > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 8, ctx_r0.namespace + "GlobalNav.done"), " ");
} }
const NAMESPACE_TOKEN = new InjectionToken('NamespaceToken');
class ContextSelectorComponent {
    constructor(analytics, contextSelectorService, dialogRef, cookieService, namespace = '') {
        this.analytics = analytics;
        this.contextSelectorService = contextSelectorService;
        this.dialogRef = dialogRef;
        this.cookieService = cookieService;
        this.namespace = namespace;
        this.searchText = '';
        this.isHierarchy = false;
        this.expandedKeys = new Set();
        this.selectedKeys = new Set();
        this.searchProperties = ['display_label'];
        this.firstTime = true;
        this.tempSelected = [];
        this.contextList = [];
        this.selectedContextLabel = '';
        this.isDisabled = (item) => {
            return (!item.children &&
                !Array.from(this.selectedKeys).includes(item.id) &&
                Array.from(this.selectedKeys).length >= this.contextSelectorService.maxSelections);
        };
    }
    ngOnInit() {
        this.contextSelectorService.contextList$.subscribe(contextList => {
            function loopSort(items) {
                items.forEach(item => {
                    if (item.children) {
                        item.children = item.children.sort((a, b) => a.display_label > b.display_label ? 1 : -1);
                        loopSort(item.children);
                    }
                });
            }
            contextList = contextList.sort((a, b) => a.display_label > b.display_label ? 1 : -1);
            loopSort(contextList);
            this.contextList = contextList;
        });
        this.contextSelectorService.currentContext$.pipe().subscribe(contexts => {
            this.selectedContextLabel = contexts[0].label;
            const contextIds = contexts.map(context => context.id);
            const flattedTree = this.flatTree(this.contextList);
            const nodesSet = new Set(flattedTree.filter(node => contextIds.includes(node.id)));
            if (this.firstTime) {
                this.firstTime = false;
                this.selectedKeys = nodesSet;
                // @ts-ignore
                const parentsId = Array.from(nodesSet).map(node => node.parent).filter(c => c);
                this.expandedKeys = new Set(this.contextList.filter(node => parentsId.includes(node.id)));
                console.log('Selection', this.selectedKeys);
                console.log('Expanded', this.expandedKeys);
            }
            const parentOfSelection = this.contextList.filter((topLevelSpace) => {
                if (topLevelSpace.children && topLevelSpace.children.length) {
                    return topLevelSpace.children.find((child) => Array.from(this.selectedKeys).includes(child.id));
                }
            });
            if (parentOfSelection && parentOfSelection.length) {
                parentOfSelection.forEach(node => {
                    this.expandedKeys.add(node);
                });
            }
        });
    }
    handleSelection(nodes) {
        let isAdminGroup = false;
        if (this.contextSelectorService.isMultiLevel) {
            const isParent = !nodes[0]?.parent;
            if (isParent) {
                isAdminGroup = true;
            }
        }
        this.tempSelected = nodes;
        if (!this.contextSelectorService.isMultiSelect && nodes.length && nodes[0].id !== Array.from(this.selectedKeys)[0].id) {
            this.expandedKeys = new Set(nodes);
            this.submitSelection(isAdminGroup);
        }
    }
    submitSelection(isAdminGroup) {
        this.contextSelectorService.selectContexts(this.tempSelected.map(node => node.id), isAdminGroup);
        this.tempSelected.forEach(node => {
            const props = { 'Space ID': node, 'Space Selected': node.displayLabel };
            this.analytics.pushEvent('Select Space Context', props);
        });
        this.dialogRef.close();
    }
    onNoClick() {
        this.dialogRef.close();
    }
    hasChildren(data) {
        return data.children && data.children.length > 0;
    }
    flatTree(tree) {
        const clonedTree = JSON.parse(JSON.stringify(tree));
        function flatten(destArray, nodeList) {
            nodeList.forEach((node) => {
                destArray.push(node);
                flatten(destArray, node.children || []);
            });
        }
        const dest = [];
        flatten(dest, clonedTree);
        return dest;
    }
    static { this.ɵfac = function ContextSelectorComponent_Factory(t) { return new (t || ContextSelectorComponent)(i0.ɵɵdirectiveInject(i1.AnalyticsService), i0.ɵɵdirectiveInject(ContextSelectorService), i0.ɵɵdirectiveInject(i3.MatDialogRef), i0.ɵɵdirectiveInject(CookieService), i0.ɵɵdirectiveInject(NAMESPACE_TOKEN)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ContextSelectorComponent, selectors: [["context-selector"]], inputs: { contextList: "contextList", selectedContextLabel: "selectedContextLabel" }, decls: 10, vars: 14, consts: [[1, "modal-body", "context-selector-modal"], ["data-automation-name", "selected-org-label", 1, "selected-context-label"], ["aria-hidden", "false", "aria-label", "Close", "data-automation-name", "cancel-button", 1, "context-modal-close", 3, "click"], [1, "size-me"], ["labelIdentifier", "display_label", "typeIdentifier", "space_type", 3, "treeData", "showSearch", "showControls", "hideIrrelevant", "searchProperties", "expandedNodes", "selectedNodes", "checkbox", "multiSelect", "maxSelections", "disabledNodeDefinitions", "hideDisabledCheckbox", "selection$", "deselection$"], [2, "text-align", "center"], ["class", "x-btn-primary context-select-btn", "style", "pointer-events: unset", 3, "disabled", "matTooltip", "matTooltipDisabled", "click", 4, "ngIf"], [1, "x-btn-primary", "context-select-btn", 2, "pointer-events", "unset", 3, "disabled", "matTooltip", "matTooltipDisabled", "click"]], template: function ContextSelectorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "h3", 1);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "mat-icon", 2);
            i0.ɵɵlistener("click", function ContextSelectorComponent_Template_mat_icon_click_4_listener() { return ctx.dialogRef.close(); });
            i0.ɵɵtext(5, "close ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 3)(7, "enel-tree-display", 4);
            i0.ɵɵlistener("selection$", function ContextSelectorComponent_Template_enel_tree_display_selection__7_listener($event) { return ctx.handleSelection($event); })("deselection$", function ContextSelectorComponent_Template_enel_tree_display_deselection__7_listener($event) { return ctx.handleSelection($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 5);
            i0.ɵɵtemplate(9, ContextSelectorComponent_button_9_Template, 5, 10, "button", 6);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.selectedContextLabel);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("treeData", ctx.contextList)("showSearch", true)("showControls", true)("hideIrrelevant", true)("searchProperties", ctx.searchProperties)("expandedNodes", ctx.expandedKeys)("selectedNodes", ctx.selectedKeys)("checkbox", ctx.contextSelectorService.isMultiSelect)("multiSelect", ctx.contextSelectorService.isMultiSelect)("maxSelections", ctx.contextSelectorService.maxSelections)("disabledNodeDefinitions", ctx.contextSelectorService.disabledNodeDefinitions)("hideDisabledCheckbox", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.contextSelectorService.isMultiSelect);
        } }, dependencies: [i1$2.NgIf, i6.MatIcon, i7.TreeComponent, i8.MatTooltip, i5.TranslatePipe], styles: [".context-selector-modal[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{border-radius:0;padding:15px}.context-selector-modal[_ngcontent-%COMP%]   .context-search-row[_ngcontent-%COMP%]{width:100%;margin-top:30px}.context-selector-modal[_ngcontent-%COMP%]   .context-search-row[_ngcontent-%COMP%]   .context-search-input[_ngcontent-%COMP%]{font:var(--font);width:100%;margin:3px 0 0;padding:6px 3px 6px 13px;resize:none;cursor:auto;white-space:nowrap;text-decoration:none;text-overflow:ellipsis;font-size:15px;color:#333;border:1px solid #b8b8b8;border-radius:3px;outline:0}.context-selector-modal[_ngcontent-%COMP%]   .selected-context-label[_ngcontent-%COMP%]{display:inline-block;margin:0;font-size:18px}.context-selector-modal[_ngcontent-%COMP%]     .mat-checkbox-frame{border-color:#0000008a!important}.context-selector-modal[_ngcontent-%COMP%]   .context-modal-close[_ngcontent-%COMP%]{font-size:25px;width:25px;text-align:center;cursor:pointer;float:right}.context-selector-modal[_ngcontent-%COMP%]   .context-list[_ngcontent-%COMP%]{margin-top:15px;overflow-y:auto;max-height:300px;clear:both}.context-selector-modal[_ngcontent-%COMP%]   .context-list[_ngcontent-%COMP%]   .context-row[_ngcontent-%COMP%]{padding:15px 30px;cursor:pointer}.context-selector-modal[_ngcontent-%COMP%]   .context-select-btn[_ngcontent-%COMP%]{margin-top:25px}.context-selector-modal[_ngcontent-%COMP%]   .size-me[_ngcontent-%COMP%]{margin-top:25px;height:500px}  input[type=search].enel-search{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='22px' height='22px' viewBox='0 0 22 22' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3Esearch%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='header' transform='translate(-1104.000000, -25.000000)' fill-rule='nonzero' stroke='%23461E7D'%3E%3Cg id='search' transform='translate(1105.000000, 26.000000)'%3E%3Ccircle id='Oval' stroke-width='1.6' transform='translate(12.142857, 7.857143) scale(-1, 1) translate(-12.142857, -7.857143) ' cx='12.1428571' cy='7.85714286' r='7.85714286'%3E%3C/circle%3E%3Cpath d='M0.414341518,19.7130766 L4.28571429,15.7142857' id='Path-2' stroke-width='2'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:left 9px center;background-size:14px 14px;border-radius:2em;-webkit-appearance:textfield;width:100%;line-height:inherit;display:inline-block;font-family:Roobert,Helvetica,Arial,sans-serif;margin:0;padding:6px 3px 6px 2em;resize:none;cursor:auto;white-space:nowrap;text-decoration:none;text-overflow:ellipsis;font-size:15px;color:#333;border:1px solid #B8B8B8;outline:0;background-color:#fff}  input[type=search].enel-search:focus{border-color:#461e7d}  .mat-mdc-dialog-container .mdc-dialog__surface{padding:24px}  mat-dialog-container{border-radius:4px}  input[type=search].enel-search::-webkit-search-cancel-button{-webkit-appearance:none;height:24px;width:24px;right:-2em;background-image:url(https://cdn.dev-apps.enelx.net/img/icons/clear.svg);cursor:pointer!important}[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:transparent!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContextSelectorComponent, [{
        type: Component,
        args: [{ selector: 'context-selector', template: "<div class=\"modal-body context-selector-modal\">\r\n    <div>\r\n        <h3 class=\"selected-context-label\" data-automation-name=\"selected-org-label\">{{ selectedContextLabel }}</h3>\r\n\r\n        <!-- close button -->\r\n        <mat-icon\r\n            aria-hidden=\"false\"\r\n            aria-label=\"Close\"\r\n            data-automation-name=\"cancel-button\"\r\n            class=\"context-modal-close\"\r\n            (click)=\"dialogRef.close()\"\r\n            >close\r\n        </mat-icon>\r\n    </div>\r\n\r\n    <div class=\"size-me\">\r\n        <enel-tree-display\r\n          [treeData]=\"contextList\"\r\n          [showSearch]=\"true\"\r\n          [showControls]='true'\r\n          [hideIrrelevant]=\"true\"\r\n          labelIdentifier=\"display_label\"\r\n          typeIdentifier=\"space_type\"\r\n          [searchProperties]=\"searchProperties\"\r\n          [expandedNodes]=\"expandedKeys\"\r\n          [selectedNodes]=\"selectedKeys\"\r\n          (selection$)=\"handleSelection($event)\"\r\n          (deselection$)=\"handleSelection($event)\"\r\n          [checkbox]=\"contextSelectorService.isMultiSelect\"\r\n          [multiSelect]=\"contextSelectorService.isMultiSelect\"\r\n          [maxSelections]='contextSelectorService.maxSelections'\r\n          [disabledNodeDefinitions]='contextSelectorService.disabledNodeDefinitions'\r\n          [hideDisabledCheckbox]='true'\r\n        >\r\n        </enel-tree-display>\r\n    </div>\r\n\r\n  <div  style=\"text-align: center\">\r\n    <button\r\n      *ngIf=\"contextSelectorService.isMultiSelect\"\r\n      class=\"x-btn-primary context-select-btn\"\r\n      style=\"pointer-events: unset\"\r\n      (click)=\"submitSelection(false)\"\r\n      [disabled]=\"!this.tempSelected.length\"\r\n      matTooltip=\"{{\r\n        contextSelectorService.isMultiSelect\r\n          ? (namespace + 'GlobalNav.done_disable_tooltip_multiple' | translate)\r\n          : (namespace + 'GlobalNav.done_disable_tooltip_no_multiple' | translate)\r\n      }}\"\r\n      [matTooltipDisabled]=\"this.tempSelected.length > 0\"\r\n    >\r\n      {{ namespace + 'GlobalNav.done' | translate }}\r\n    </button>\r\n  </div>\r\n</div>\r\n", styles: [".context-selector-modal .modal-content{border-radius:0;padding:15px}.context-selector-modal .context-search-row{width:100%;margin-top:30px}.context-selector-modal .context-search-row .context-search-input{font:var(--font);width:100%;margin:3px 0 0;padding:6px 3px 6px 13px;resize:none;cursor:auto;white-space:nowrap;text-decoration:none;text-overflow:ellipsis;font-size:15px;color:#333;border:1px solid #b8b8b8;border-radius:3px;outline:0}.context-selector-modal .selected-context-label{display:inline-block;margin:0;font-size:18px}.context-selector-modal ::ng-deep .mat-checkbox-frame{border-color:#0000008a!important}.context-selector-modal .context-modal-close{font-size:25px;width:25px;text-align:center;cursor:pointer;float:right}.context-selector-modal .context-list{margin-top:15px;overflow-y:auto;max-height:300px;clear:both}.context-selector-modal .context-list .context-row{padding:15px 30px;cursor:pointer}.context-selector-modal .context-select-btn{margin-top:25px}.context-selector-modal .size-me{margin-top:25px;height:500px}::ng-deep input[type=search].enel-search{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='22px' height='22px' viewBox='0 0 22 22' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3Esearch%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='header' transform='translate(-1104.000000, -25.000000)' fill-rule='nonzero' stroke='%23461E7D'%3E%3Cg id='search' transform='translate(1105.000000, 26.000000)'%3E%3Ccircle id='Oval' stroke-width='1.6' transform='translate(12.142857, 7.857143) scale(-1, 1) translate(-12.142857, -7.857143) ' cx='12.1428571' cy='7.85714286' r='7.85714286'%3E%3C/circle%3E%3Cpath d='M0.414341518,19.7130766 L4.28571429,15.7142857' id='Path-2' stroke-width='2'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:left 9px center;background-size:14px 14px;border-radius:2em;-webkit-appearance:textfield;width:100%;line-height:inherit;display:inline-block;font-family:Roobert,Helvetica,Arial,sans-serif;margin:0;padding:6px 3px 6px 2em;resize:none;cursor:auto;white-space:nowrap;text-decoration:none;text-overflow:ellipsis;font-size:15px;color:#333;border:1px solid #B8B8B8;outline:0;background-color:#fff}::ng-deep input[type=search].enel-search:focus{border-color:#461e7d}::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface{padding:24px}::ng-deep mat-dialog-container{border-radius:4px}::ng-deep input[type=search].enel-search::-webkit-search-cancel-button{-webkit-appearance:none;height:24px;width:24px;right:-2em;background-image:url(https://cdn.dev-apps.enelx.net/img/icons/clear.svg);cursor:pointer!important}::-webkit-scrollbar-track{background:transparent!important}\n"] }]
    }], function () { return [{ type: i1.AnalyticsService }, { type: ContextSelectorService }, { type: i3.MatDialogRef }, { type: CookieService }, { type: undefined, decorators: [{
                type: Inject,
                args: [NAMESPACE_TOKEN]
            }] }]; }, { contextList: [{
            type: Input
        }], selectedContextLabel: [{
            type: Input
        }] }); })();

class GlobalAlertService {
    constructor() {
        this.subject = new Subject();
    }
    get messages() {
        return this.subject;
    }
    setSuccess(message) {
        this.messages.next({
            type: 'success',
            message,
        });
    }
    setError(message) {
        this.messages.next({
            type: 'error',
            message,
        });
    }
    static { this.ɵfac = function GlobalAlertService_Factory(t) { return new (t || GlobalAlertService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GlobalAlertService, factory: GlobalAlertService.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalAlertService, [{
        type: Injectable
    }], null, null); })();

function MenuControlComponent_ng_container_0_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.hint, "");
} }
function MenuControlComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵelementStart(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MenuControlComponent_ng_container_0_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementStart(4, "span", 5);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.label.charAt(0).toUpperCase());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.hint > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.label);
} }
function MenuControlComponent_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.icon);
} }
class MenuControlComponent {
    constructor() {
        this.icon = '';
        this.label = '';
        this.hint = 0;
    }
    static { this.ɵfac = function MenuControlComponent_Factory(t) { return new (t || MenuControlComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MenuControlComponent, selectors: [["menu-control"]], inputs: { icon: "icon", label: "label", hint: "hint" }, decls: 2, vars: 2, consts: [["class", "user-info", 4, "ngIf"], ["class", "hamburger", 4, "ngIf"], [1, "user-info"], [1, "circle"], ["class", "notify-hint", 4, "ngIf"], [1, "user-name"], [1, "notify-hint"], [1, "hamburger"]], template: function MenuControlComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, MenuControlComponent_ng_container_0_Template, 6, 3, "ng-container", 0);
            i0.ɵɵtemplate(1, MenuControlComponent_mat_icon_1_Template, 2, 1, "mat-icon", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.label);
        } }, dependencies: [i1$2.NgIf, i6.MatIcon], styles: ["[_nghost-%COMP%]{display:flex;flex-wrap:nowrap;justify-content:space-between;align-items:center;cursor:pointer;padding-left:20px;position:relative;height:30px;line-height:30px;min-width:65px;color:#fff}[_nghost-%COMP%]   span[_ngcontent-%COMP%]{margin-right:10px;white-space:nowrap}[_nghost-%COMP%]   .hamburger[_ngcontent-%COMP%]{font-size:28px;height:28px;width:28px}[_nghost-%COMP%]   .user-name[_ngcontent-%COMP%]{display:block;max-width:200px;overflow:hidden;text-overflow:ellipsis}.user-info[_ngcontent-%COMP%]{position:relative}.notify-hint[_ngcontent-%COMP%]{position:absolute;top:0;width:12px;padding:5px;height:12px;border-radius:5px;background:var(--warn-color);color:#fff;font-size:10px;display:flex;align-items:center;justify-content:center}@media screen and (max-width: 768px){[_nghost-%COMP%]{margin-right:0;padding-left:0;min-width:40px}[_nghost-%COMP%]   .hamburger[_ngcontent-%COMP%]{font-size:24px;height:24px;width:24px}[_nghost-%COMP%]   .user-name[_ngcontent-%COMP%]{display:none}}", "input[_ngcontent-%COMP%]:focus, input[_ngcontent-%COMP%]:active, input[_ngcontent-%COMP%]:hover, select[_ngcontent-%COMP%]:focus, select[_ngcontent-%COMP%]:active, select[_ngcontent-%COMP%]:hover, textarea[_ngcontent-%COMP%]:focus, textarea[_ngcontent-%COMP%]:active, textarea[_ngcontent-%COMP%]:hover{border:none}.mat-mdc-form-field[_ngcontent-%COMP%]{width:100%}.mat-expansion-panel-header[_ngcontent-%COMP%]{background:var(--row-highlight);border-top:solid 1px var(--row-highlight-hover);border-bottom:solid 1px var(--row-highlight-hover);border-radius:0;padding-left:40px}.mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]:hover, .mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]:focus{background:var(--row-highlight)}.mat-expansion-panel-header-title[_ngcontent-%COMP%]{color:var(--primary-color);letter-spacing:.5px}.circle[_ngcontent-%COMP%]{background:var(--accent-color);color:#fff;border-radius:32px;height:30px;width:30px;text-align:center;line-height:32px;padding-left:1px;font-weight:700}  .mat-mdc-dialog-container{background-color:#fff!important}  .mat-expansion-panel-header{font-family:var(--fonts)!important}  .mat-expansion-panel-content{font-family:var(--fonts)!important}.mat-mdc-form-field-error[_ngcontent-%COMP%]{color:red}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuControlComponent, [{
        type: Component,
        args: [{ selector: 'menu-control', template: "<ng-container *ngIf=\"label\" class=\"user-info\">\r\n  <span class=\"circle\">{{label.charAt(0).toUpperCase()}}</span>\r\n  <span *ngIf=\"hint > 0\" class=\"notify-hint\"> {{ hint }}</span>\r\n  <span class=\"user-name\">{{ label }}</span>\r\n</ng-container>\r\n<mat-icon *ngIf=\"!label\" class=\"hamburger\">{{icon}}</mat-icon>\r\n", styles: [":host{display:flex;flex-wrap:nowrap;justify-content:space-between;align-items:center;cursor:pointer;padding-left:20px;position:relative;height:30px;line-height:30px;min-width:65px;color:#fff}:host span{margin-right:10px;white-space:nowrap}:host .hamburger{font-size:28px;height:28px;width:28px}:host .user-name{display:block;max-width:200px;overflow:hidden;text-overflow:ellipsis}.user-info{position:relative}.notify-hint{position:absolute;top:0;width:12px;padding:5px;height:12px;border-radius:5px;background:var(--warn-color);color:#fff;font-size:10px;display:flex;align-items:center;justify-content:center}@media screen and (max-width: 768px){:host{margin-right:0;padding-left:0;min-width:40px}:host .hamburger{font-size:24px;height:24px;width:24px}:host .user-name{display:none}}\n", "input:focus,input:active,input:hover,select:focus,select:active,select:hover,textarea:focus,textarea:active,textarea:hover{border:none}.mat-mdc-form-field{width:100%}.mat-expansion-panel-header{background:var(--row-highlight);border-top:solid 1px var(--row-highlight-hover);border-bottom:solid 1px var(--row-highlight-hover);border-radius:0;padding-left:40px}.mat-expansion-panel-header.mat-expanded:hover,.mat-expansion-panel-header.mat-expanded:focus{background:var(--row-highlight)}.mat-expansion-panel-header-title{color:var(--primary-color);letter-spacing:.5px}.circle{background:var(--accent-color);color:#fff;border-radius:32px;height:30px;width:30px;text-align:center;line-height:32px;padding-left:1px;font-weight:700}::ng-deep .mat-mdc-dialog-container{background-color:#fff!important}::ng-deep .mat-expansion-panel-header{font-family:var(--fonts)!important}::ng-deep .mat-expansion-panel-content{font-family:var(--fonts)!important}.mat-mdc-form-field-error{color:red}\n"] }]
    }], null, { icon: [{
            type: Input
        }], label: [{
            type: Input
        }], hint: [{
            type: Input
        }] }); })();

function MenuComponent_div_0_div_1_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "span", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", item_r3.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", item_r3.label, " ");
} }
function MenuComponent_div_0_div_1_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", item_r3.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r3.label);
} }
function MenuComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("click", function MenuComponent_div_0_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const item_r3 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.onClick(item_r3)); });
    i0.ɵɵtemplate(1, MenuComponent_div_0_div_1_a_1_Template, 3, 2, "a", 4);
    i0.ɵɵtemplate(2, MenuComponent_div_0_div_1_a_2_Template, 2, 2, "a", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r3.external);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r3.external);
} }
function MenuComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, MenuComponent_div_0_div_1_Template, 3, 2, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", section_r1.children);
} }
class MenuComponent {
    constructor() {
        this.sections = [];
        this.select = new EventEmitter();
        this.close = new EventEmitter();
    }
    onClick(menuItem) {
        this.select.emit(menuItem);
    }
    onClose() {
        this.close.emit(void 0);
    }
    static { this.ɵfac = function MenuComponent_Factory(t) { return new (t || MenuComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MenuComponent, selectors: [["app-menu"]], inputs: { sections: "sections" }, outputs: { select: "select", close: "close" }, decls: 1, vars: 1, consts: [["class", "menu-section", 4, "ngFor", "ngForOf"], [1, "menu-section"], ["class", "menu-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "menu-item", 3, "click"], ["target", "_blank", 3, "href", 4, "ngIf"], [3, "href", 4, "ngIf"], ["target", "_blank", 3, "href"], [1, "fa", "fa-external-link-alt"], [3, "href"]], template: function MenuComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, MenuComponent_div_0_Template, 2, 1, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngForOf", ctx.sections);
        } }, dependencies: [i1$2.NgForOf, i1$2.NgIf], styles: ["[_nghost-%COMP%]{display:block;justify-content:flex-end;padding:5px 20px}.menu-section[_ngcontent-%COMP%]{display:flex;flex-direction:column;min-width:-moz-fit-content;min-width:fit-content;padding:10px 20px}.menu-item[_ngcontent-%COMP%]{line-height:25px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuComponent, [{
        type: Component,
        args: [{ selector: 'app-menu', template: "<div class=\"menu-section\" *ngFor=\"let section of sections\">\r\n  <div class=\"menu-item\" (click)=\"onClick(item)\" *ngFor=\"let item of section.children\">\r\n    <a *ngIf=\"item.external\" [href]=\"item.link\" target=\"_blank\">{{ item.label }}\r\n      <span class=\"fa fa-external-link-alt\"></span>\r\n    </a>\r\n    <a *ngIf=\"!item.external\" [href]=\"item.link\">{{ item.label }}</a>\r\n  </div>\r\n</div>\r\n", styles: [":host{display:block;justify-content:flex-end;padding:5px 20px}.menu-section{display:flex;flex-direction:column;min-width:-moz-fit-content;min-width:fit-content;padding:10px 20px}.menu-item{line-height:25px}\n"] }]
    }], null, { sections: [{
            type: Input
        }], select: [{
            type: Output
        }], close: [{
            type: Output
        }] }); })();

class ProfileService {
    getPrimaryData(data) {
        const primaryIndex = data.findIndex((item) => item.primary === true);
        if (primaryIndex > 0) {
            return data[primaryIndex];
        }
        else {
            return data[0];
        }
    }
    static { this.ɵfac = function ProfileService_Factory(t) { return new (t || ProfileService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProfileService, factory: ProfileService.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfileService, [{
        type: Injectable
    }], null, null); })();

function EditProfileComponent_mat_error_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_mat_error_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r1.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_mat_error_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r2.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_mat_error_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r3.namespace + "GlobalNav.errors.invalid_email"), " ");
} }
function EditProfileComponent_ng_container_35_ng_container_1_mat_option_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const callingCode_r22 = ctx.$implicit;
    i0.ɵɵproperty("value", callingCode_r22.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" +", callingCode_r22.code, " ", callingCode_r22.country, " ");
} }
function EditProfileComponent_ng_container_35_ng_container_1_mat_error_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r19.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_ng_container_35_ng_container_1_mat_error_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r20.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_ng_container_35_ng_container_1_mat_error_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r21.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_ng_container_35_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 19);
    i0.ɵɵelementStart(1, "mat-form-field", 4)(2, "mat-label");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-select", 20);
    i0.ɵɵlistener("selectionChange", function EditProfileComponent_ng_container_35_ng_container_1_Template_mat_select_selectionChange_5_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.onPhoneFieldChange()); });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementStart(7, "mat-option");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, EditProfileComponent_ng_container_35_ng_container_1_mat_option_10_Template, 2, 3, "mat-option", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, EditProfileComponent_ng_container_35_ng_container_1_mat_error_11_Template, 3, 3, "mat-error", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "mat-form-field", 4)(13, "mat-label");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "input", 21);
    i0.ɵɵlistener("input", function EditProfileComponent_ng_container_35_ng_container_1_Template_input_input_16_listener() { i0.ɵɵrestoreView(_r24); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.onPhoneFieldChange()); });
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, EditProfileComponent_ng_container_35_ng_container_1_mat_error_18_Template, 3, 3, "mat-error", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "mat-form-field", 4)(20, "mat-label");
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "input", 22);
    i0.ɵɵlistener("input", function EditProfileComponent_ng_container_35_ng_container_1_Template_input_input_23_listener() { i0.ɵɵrestoreView(_r24); const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.onPhoneFieldChange()); });
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(25, EditProfileComponent_ng_container_35_ng_container_1_mat_error_25_Template, 3, 3, "mat-error", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext();
    const phone_r15 = ctx_r27.$implicit;
    const phoneIndex_r16 = ctx_r27.index;
    const ctx_r17 = i0.ɵɵnextContext();
    let tmp_6_0;
    let tmp_10_0;
    let tmp_14_0;
    i0.ɵɵproperty("formGroup", ctx_r17.getFormGroupFromAbstractControl(phone_r15));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 15, ctx_r17.namespace + "GlobalNav.profile.country_code"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "country_code_", phoneIndex_r16, "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(6, 17, ctx_r17.hasAnyPhoneField ? ctx_r17.namespace + "GlobalNav.profile.placeholder.country_code_required" : ctx_r17.namespace + "GlobalNav.profile.placeholder.country_code"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 19, ctx_r17.namespace + "GlobalNav.profile.placeholder.country_code"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r17.callingCodes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_6_0 = phone_r15.get("country_code")) == null ? null : tmp_6_0.hasError("required"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 21, ctx_r17.namespace + "GlobalNav.profile.phone_number"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "phone_number_", phoneIndex_r16, "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(17, 23, ctx_r17.hasAnyPhoneField ? ctx_r17.namespace + "GlobalNav.profile.placeholder.phone_number_required" : ctx_r17.namespace + "GlobalNav.profile.placeholder.phone_number"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (tmp_10_0 = phone_r15.get("phone_number")) == null ? null : tmp_10_0.hasError("required"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(22, 25, ctx_r17.namespace + "GlobalNav.profile.extension"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "extension_", phoneIndex_r16, "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(24, 27, ctx_r17.namespace + "GlobalNav.profile.placeholder.extension"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (tmp_14_0 = phone_r15.get("extension")) == null ? null : tmp_14_0.hasError("required"));
} }
function EditProfileComponent_ng_container_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EditProfileComponent_ng_container_35_ng_container_1_Template, 26, 29, "ng-container", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const phone_r15 = ctx.$implicit;
    let tmp_0_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_0_0 = phone_r15.get("primary")) == null ? null : tmp_0_0.value);
} }
function EditProfileComponent_ng_container_36_ng_container_1_mat_error_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r31.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_ng_container_36_ng_container_1_mat_error_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r32.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_ng_container_36_ng_container_1_mat_option_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r38 = ctx.$implicit;
    i0.ɵɵproperty("value", country_r38.name);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", country_r38.display_label, " ");
} }
function EditProfileComponent_ng_container_36_ng_container_1_mat_error_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r34.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_ng_container_36_ng_container_1_mat_option_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const state_r39 = ctx.$implicit;
    i0.ɵɵproperty("value", state_r39.name);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", state_r39.display_label, " ");
} }
function EditProfileComponent_ng_container_36_ng_container_1_mat_error_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r36.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_ng_container_36_ng_container_1_mat_error_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r37.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_ng_container_36_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 19);
    i0.ɵɵelementStart(1, "mat-form-field", 4)(2, "mat-label");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "input", 24);
    i0.ɵɵlistener("input", function EditProfileComponent_ng_container_36_ng_container_1_Template_input_input_5_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r40.onAddressFieldChange()); });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, EditProfileComponent_ng_container_36_ng_container_1_mat_error_7_Template, 3, 3, "mat-error", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "mat-form-field", 4)(9, "mat-label");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "input", 25);
    i0.ɵɵlistener("input", function EditProfileComponent_ng_container_36_ng_container_1_Template_input_input_12_listener() { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r42.onAddressFieldChange()); });
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "mat-form-field", 4)(15, "mat-label");
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "input", 26);
    i0.ɵɵlistener("input", function EditProfileComponent_ng_container_36_ng_container_1_Template_input_input_18_listener() { i0.ɵɵrestoreView(_r41); const ctx_r43 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r43.onAddressFieldChange()); });
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, EditProfileComponent_ng_container_36_ng_container_1_mat_error_20_Template, 3, 3, "mat-error", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "mat-form-field", 4)(22, "mat-label");
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "mat-select", 27);
    i0.ɵɵlistener("selectionChange", function EditProfileComponent_ng_container_36_ng_container_1_Template_mat_select_selectionChange_25_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r44 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r44.onCountryChange($event)); });
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementStart(27, "mat-option");
    i0.ɵɵtext(28);
    i0.ɵɵpipe(29, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(30, EditProfileComponent_ng_container_36_ng_container_1_mat_option_30_Template, 2, 2, "mat-option", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(31, EditProfileComponent_ng_container_36_ng_container_1_mat_error_31_Template, 3, 3, "mat-error", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "mat-form-field", 4)(33, "mat-label");
    i0.ɵɵtext(34);
    i0.ɵɵpipe(35, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "mat-select", 28);
    i0.ɵɵlistener("input", function EditProfileComponent_ng_container_36_ng_container_1_Template_mat_select_input_36_listener() { i0.ɵɵrestoreView(_r41); const ctx_r45 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r45.onAddressFieldChange()); });
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵelementStart(38, "mat-option");
    i0.ɵɵtext(39);
    i0.ɵɵpipe(40, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(41, EditProfileComponent_ng_container_36_ng_container_1_mat_option_41_Template, 2, 2, "mat-option", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(42, EditProfileComponent_ng_container_36_ng_container_1_mat_error_42_Template, 3, 3, "mat-error", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "mat-form-field", 4)(44, "mat-label");
    i0.ɵɵtext(45);
    i0.ɵɵpipe(46, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "input", 29);
    i0.ɵɵlistener("input", function EditProfileComponent_ng_container_36_ng_container_1_Template_input_input_47_listener() { i0.ɵɵrestoreView(_r41); const ctx_r46 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r46.onAddressFieldChange()); });
    i0.ɵɵpipe(48, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(49, EditProfileComponent_ng_container_36_ng_container_1_mat_error_49_Template, 3, 3, "mat-error", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext();
    const address_r28 = ctx_r47.$implicit;
    const addressIndex_r29 = ctx_r47.index;
    const ctx_r30 = i0.ɵɵnextContext();
    let tmp_4_0;
    let tmp_11_0;
    let tmp_17_0;
    let tmp_23_0;
    let tmp_27_0;
    i0.ɵɵproperty("formGroup", ctx_r30.getFormGroupFromAbstractControl(address_r28));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 28, ctx_r30.namespace + "GlobalNav.profile.address_1"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "address_1_", addressIndex_r29, "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(6, 30, ctx_r30.hasAnyAddressField ? ctx_r30.namespace + "GlobalNav.profile.placeholder.address1_required" : ctx_r30.namespace + "GlobalNav.profile.placeholder.address1"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (tmp_4_0 = address_r28.get("address_1")) == null ? null : tmp_4_0.hasError("required"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 32, ctx_r30.namespace + "GlobalNav.profile.address_2"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "address_2_", addressIndex_r29, "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(13, 34, ctx_r30.namespace + "GlobalNav.profile.placeholder.address2"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 36, ctx_r30.namespace + "GlobalNav.profile.city"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "city_", addressIndex_r29, "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(19, 38, ctx_r30.hasAnyAddressField ? ctx_r30.namespace + "GlobalNav.profile.placeholder.city_required" : ctx_r30.namespace + "GlobalNav.profile.placeholder.city"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (tmp_11_0 = address_r28.get("city")) == null ? null : tmp_11_0.hasError("required"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 40, ctx_r30.namespace + "GlobalNav.profile.country"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "country_", addressIndex_r29, "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(26, 42, ctx_r30.hasAnyAddressField ? ctx_r30.namespace + "GlobalNav.profile.placeholder.country_selector_required" : ctx_r30.namespace + "GlobalNav.profile.placeholder.country_selector"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(29, 44, ctx_r30.namespace + "GlobalNav.profile.placeholder.country_selector"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r30.countries);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_17_0 = address_r28.get("country")) == null ? null : tmp_17_0.hasError("required"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(35, 46, ctx_r30.namespace + "GlobalNav.profile.state_province"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "state_province_", addressIndex_r29, "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(37, 48, ctx_r30.hasAnyAddressField ? ctx_r30.namespace + "GlobalNav.profile.placeholder.state_selector_required" : ctx_r30.namespace + "GlobalNav.profile.placeholder.state_selector"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(40, 50, ctx_r30.namespace + "GlobalNav.profile.placeholder.state_selector"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r30.states);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_23_0 = address_r28.get("state_province")) == null ? null : tmp_23_0.hasError("required"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(46, 52, ctx_r30.namespace + "GlobalNav.profile.postal_code"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "postal_code_", addressIndex_r29, "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(48, 54, ctx_r30.hasAnyAddressField ? ctx_r30.namespace + "GlobalNav.profile.placeholder.zip_required" : ctx_r30.namespace + "GlobalNav.profile.placeholder.zip"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (tmp_27_0 = address_r28.get("postal_code")) == null ? null : tmp_27_0.hasError("required"));
} }
function EditProfileComponent_ng_container_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EditProfileComponent_ng_container_36_ng_container_1_Template, 50, 56, "ng-container", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const address_r28 = ctx.$implicit;
    let tmp_0_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_0_0 = address_r28.get("primary")) == null ? null : tmp_0_0.value);
} }
function EditProfileComponent_mat_option_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const locale_r48 = ctx.$implicit;
    i0.ɵɵproperty("value", locale_r48.locale_name);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", locale_r48.display_label, " ");
} }
function EditProfileComponent_mat_error_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r7.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_mat_option_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const timezone_r49 = ctx.$implicit;
    i0.ɵɵproperty("value", timezone_r49.timezone_name);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", timezone_r49.display_label, " ");
} }
function EditProfileComponent_mat_error_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r9.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_mat_option_65_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const unitSystem_r50 = ctx.$implicit;
    i0.ɵɵproperty("value", unitSystem_r50.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", unitSystem_r50.display_label, " ");
} }
function EditProfileComponent_mat_error_66_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r11.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_mat_option_73_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const application_r51 = ctx.$implicit;
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r12.applications[application_r51.key].name);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.applications[application_r51.key].display_label, " ");
} }
function EditProfileComponent_mat_error_75_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r13.namespace + "GlobalNav.errors.required"), " ");
} }
function EditProfileComponent_mat_expansion_panel_76_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-expansion-panel", 11)(1, "mat-expansion-panel-header", 2)(2, "mat-panel-title");
    i0.ɵɵtext(3, "Notification Settings");
    i0.ɵɵelementEnd()()();
} }
class EditProfileComponent {
    constructor(namespace = '', profileService, _fb, globalNavService) {
        this.namespace = namespace;
        this.profileService = profileService;
        this._fb = _fb;
        this.globalNavService = globalNavService;
        this.countries = [];
        this.timezones = [];
        this.locales = [];
        this.unitSystems = [];
        this.applications = {};
        this.states = [];
        this.callingCodes = {};
        this.hasAnyAddressField = false;
        this.hasAnyPhoneField = false;
        this.isCommunityUser = false;
        this.work = 'WORK';
        this.FormGroup = FormGroup;
        this.userData = null;
        this.metadata = null;
        this.selectedCountry = {};
        this.primaryEmail = {
            email_address: '',
            email_type: this.work,
            primary: true,
        };
        this.primaryAddress = {
            address_1: '',
            address_2: '',
            city: '',
            country: '',
            state_province: '',
            postal_code: 0,
            address_type: 'PO_BOX',
            primary: true,
        };
        this.primaryPhone = {
            phone_number: '',
            phone_type: this.work,
            primary: true,
            extension: 0,
            country_code: 0,
        };
        this.primaryOrg = {
            id: '',
            display_label: '',
        };
    }
    get addresses() {
        return this.userUpdateForm.get('addresses');
    }
    get phones() {
        return this.userUpdateForm.get('phones');
    }
    get defaultTimeZone() {
        return this.userUpdateForm.get('timezone');
    }
    get defaultLocale() {
        return this.userUpdateForm.get('locale');
    }
    get defaultUnitSystem() {
        return this.userUpdateForm.get('unit_system');
    }
    get defaultHomeApplication() {
        return this.userUpdateForm.get('home_application');
    }
    get userId() {
        return this.userUpdateForm.get('user_id');
    }
    get organization() {
        return this.userUpdateForm.get('organization');
    }
    get firstName() {
        return this.userUpdateForm.get('first_name');
    }
    get lastName() {
        return this.userUpdateForm.get('last_name');
    }
    get email() {
        return this.userUpdateForm.get('email');
    }
    get title() {
        return this.userUpdateForm.get('title');
    }
    get stateProvince() {
        return this.addresses.at(0).get('state_province');
    }
    get address1() {
        return this.addresses.at(0).get('address_1');
    }
    get address2() {
        return this.addresses.at(0).get('address_1');
    }
    get city() {
        return this.addresses.at(0).get('city');
    }
    get postalCode() {
        return this.addresses.at(0).get('postal_code');
    }
    get country() {
        return this.addresses.at(0).get('country');
    }
    get countryCode() {
        return this.phones.at(0).get('country_code');
    }
    get phoneExtension() {
        return this.phones.at(0).get('extension');
    }
    get phoneNumber() {
        return this.phones.at(0).get('phone_number');
    }
    getAddressForm(address) {
        if (address) {
            return this._fb.group({
                address_1: [address.address_1],
                address_2: [address.address_2],
                city: [address.city],
                country: [address.country],
                state_province: [{ value: address.state_province, disabled: true }],
                postal_code: [address.postal_code],
                primary: [address.primary],
                address_type: [address.address_type],
            });
        }
        else {
            return this._fb.group({
                address_1: [''],
                address_2: [''],
                city: [''],
                country: [''],
                state_province: [''],
                postal_code: [''],
                primary: [true],
                address_type: ['WORK'],
            });
        }
    }
    getFormGroupFromAbstractControl(control) {
        return control;
    }
    getPhoneForm(phone) {
        if (phone) {
            return this._fb.group({
                phone_number: [phone.phone_number],
                country_code: [phone.country_code],
                extension: [phone.extension],
                phone_type: [phone.phone_type],
                primary: [phone.primary],
            });
        }
        else {
            return this._fb.group({
                phone_number: [''],
                country_code: [''],
                extension: [''],
                phone_type: ['WORK'],
                primary: [true],
            });
        }
    }
    populateUserForm() {
        this.userData.profile.contact_details.addresses.forEach((address, index) => {
            if (!address.primary) {
                this.addresses.push(this.getAddressForm(address));
            }
        });
        this.addresses.insert(0, this.getAddressForm(this.primaryAddress));
        this.userData.profile.contact_details.phones.forEach((phone, index) => {
            if (!phone.primary) {
                this.phones.push(this.getPhoneForm(phone));
            }
        });
        this.phones.insert(0, this.getPhoneForm(this.primaryPhone));
        this.defaultTimeZone.setValue(this.userData.preferences.default_time_zone);
        this.defaultLocale.setValue(this.userData.preferences.default_locale);
        this.defaultUnitSystem.setValue(this.userData.preferences.default_unit_system);
        this.defaultHomeApplication.setValue(this.userData.preferences.default_page);
        this.userId.setValue(this.userData.user_id);
        this.organization.setValue(this.primaryOrg.organization_id);
        this.firstName.setValue(this.userData.profile.names.first_name);
        this.lastName.setValue(this.userData.profile.names.last_system_name);
        this.email.setValue(this.primaryEmail.email_address);
        this.title.setValue(this.userData.title);
        if (this.isCommunityUser) {
            // disable all profile fields here
            this.firstName.disable();
            this.lastName.disable();
            this.email.disable();
            this.organization.disable();
            this.title.disable();
            this.addresses.controls.forEach((control) => {
                control.disable();
            });
            this.phones.controls.forEach((control) => {
                control.disable();
            });
        }
    }
    populateStates(countryInput) {
        const foundCountry = this.countries.find((country) => country.name === countryInput);
        if (foundCountry && foundCountry.provinces) {
            this.states = foundCountry.provinces;
            this.stateProvince.enable();
        }
        else {
            this.states = [];
            this.stateProvince.setValue('');
            this.stateProvince.disable();
        }
    }
    populateCountryCodes() {
        this.callingCodes = this.countries
            .map((country) => {
            return {
                code: country.callingCodes[0],
                country: country.display_label,
            };
        })
            .sort((a, b) => {
            return a.country.localeCompare(b.country);
        });
    }
    onCountryChange($event) {
        this.populateStates($event.value);
        this.onAddressFieldChange();
    }
    initForm() {
        if (this.userData && this.userData.profile && this.metadata) {
            this.primaryEmail = this.profileService.getPrimaryData(this.userData.profile.contact_details.emails);
            this.primaryAddress = this.profileService.getPrimaryData(this.userData.profile.contact_details.addresses);
            this.primaryPhone = this.profileService.getPrimaryData(this.userData.profile.contact_details.phones);
            this.primaryOrg = this.profileService.getPrimaryData(this.userData.profile.organizations);
            this.resetForm();
            this.populateUserForm();
            if (this.primaryAddress) {
                this.populateStates(this.primaryAddress.country);
            }
            this.populateCountryCodes();
        }
    }
    resetForm() {
        this.userUpdateForm.reset();
        this.addresses.clear();
        this.phones.clear();
    }
    onAddressFieldChange() {
        const nowHasAnyAddrField = (this.stateProvince.value && this.stateProvince.value.trim().length > 0) ||
            (this.address1.value && this.address1.value.trim().length > 0) ||
            (this.address2.value && this.address2.value.trim().length > 0) ||
            (this.country.value && this.country.value.trim().length > 0) ||
            (this.city.value && this.city.value.trim().length > 0) ||
            !(this.postalCode.value === undefined || this.postalCode.value === '');
        const frm = this.addresses.parent;
        if (nowHasAnyAddrField) {
            this.address1.setValidators([Validators.required]);
            this.address1.updateValueAndValidity();
            this.country.setValidators([Validators.required]);
            this.country.updateValueAndValidity();
            this.stateProvince.setValidators([Validators.required]);
            this.stateProvince.updateValueAndValidity();
            this.city.setValidators([Validators.required]);
            this.city.updateValueAndValidity();
            this.postalCode.setValidators([
                Validators.required,
                Validators.pattern('[0-9]*'),
            ]);
            this.postalCode.updateValueAndValidity();
        }
        else {
            this.address1.setValidators([]);
            this.address1.setErrors(null);
            this.city.setValidators([]);
            this.city.setErrors(null);
            this.country.setValidators([]);
            this.country.setErrors(null);
            this.stateProvince.setValidators([]);
            this.stateProvince.setErrors(null);
            this.postalCode.setValidators([]);
            this.postalCode.setErrors(null);
            frm.setErrors(null);
        }
        this.hasAnyAddressField = nowHasAnyAddrField;
        frm.markAsDirty();
        frm.updateValueAndValidity();
        this.hasAnyAddressField = nowHasAnyAddrField;
    }
    onPhoneFieldChange() {
        const nowHasPhoneFieldRequired = (this.countryCode.value && this.countryCode.value.length > 0) ||
            (this.phoneNumber.value && this.phoneNumber.value.length > 0);
        const frm = this.phones.parent;
        if (nowHasPhoneFieldRequired) {
            this.countryCode.setValidators([Validators.required]);
            this.countryCode.updateValueAndValidity();
            this.phoneNumber.setValidators([Validators.required]);
            this.phoneNumber.updateValueAndValidity();
        }
        else {
            this.countryCode.setValidators([]);
            this.countryCode.setErrors(null);
            this.phoneNumber.setValidators([]);
            this.phoneNumber.setErrors(null);
            frm.setErrors(null);
        }
        this.hasAnyPhoneField = nowHasPhoneFieldRequired;
        frm.markAsDirty();
        frm.updateValueAndValidity();
        this.hasAnyPhoneField = nowHasPhoneFieldRequired;
    }
    ngOnInit() {
        this.globalNavService.userData$.subscribe((userData) => {
            if (userData) {
                this.userData = userData;
                this.initForm();
            }
        });
        this.globalNavService.userRolesList$.subscribe((userRoles) => {
            if (userRoles) {
                if (userRoles.length > 0) {
                    this.isCommunityUser = userRoles.some((role) => role.business_role == 'COMMUNITY_USER');
                }
                this.initForm();
            }
        });
        this.globalNavService.metaData$.subscribe((metadata) => {
            if (metadata) {
                this.metadata = metadata;
                const { applications, countries, locales, timezones, unit_systems } = this.metadata;
                this.unitSystems = unit_systems;
                this.applications = applications;
                this.countries = countries;
                this.locales = locales;
                this.timezones = timezones;
                this.initForm();
            }
        });
    }
    static { this.ɵfac = function EditProfileComponent_Factory(t) { return new (t || EditProfileComponent)(i0.ɵɵdirectiveInject(NAMESPACE_TOKEN), i0.ɵɵdirectiveInject(ProfileService), i0.ɵɵdirectiveInject(i2.FormBuilder), i0.ɵɵdirectiveInject(GlobalNavService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EditProfileComponent, selectors: [["app-edit-profile"]], inputs: { userUpdateForm: "userUpdateForm" }, features: [i0.ɵɵProvidersFeature([], [{ provide: ControlContainer, useExisting: NgForm }])], decls: 77, vars: 73, consts: [["ngModelGroup", "app-edit-profile", "id", "userUpdate", 3, "formGroup"], ["togglePosition", "after", 3, "expanded"], ["collapsedHeight", "42px", "expandedHeight", "42px"], [1, "panel-content"], ["appearance", "outline", "floatLabel", "always"], ["id", "first_name", "matInput", "", "maxlength", "80", "required", "", "formControlName", "first_name", "data-automation", "first_name", 3, "placeholder"], [4, "ngIf"], ["id", "last_name", "matInput", "", "maxlength", "80", "required", "", "formControlName", "last_name", "data-automation", "last_name", 3, "placeholder"], ["id", "email", "matInput", "", "required", "", "maxlength", "80", "formControlName", "email", "data-automation", "email", 3, "placeholder"], ["id", "title", "matInput", "", "maxlength", "80", "formControlName", "title", "data-automation", "title", 3, "placeholder"], [4, "ngFor", "ngForOf"], ["togglePosition", "after", "expanded", "true"], ["required", "", "formControlName", "locale", "data-automation", "locale", 3, "placeholder"], [3, "value", 4, "ngFor", "ngForOf"], ["required", "", "formControlName", "timezone", "data-automation", "locale", 3, "placeholder"], ["required", "", "formControlName", "unit_system", "data-automation", "unit_system", 3, "placeholder"], ["required", "", "formControlName", "home_application", "data-automation", "home_application", 3, "placeholder"], ["togglePosition", "after", "expanded", "true", 4, "ngIf"], [3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["formControlName", "country_code", "data-automation", "country_code", 3, "id", "placeholder", "selectionChange"], ["matInput", "", "formControlName", "phone_number", "data-automation", "phone_number", 3, "id", "placeholder", "input"], ["matInput", "", "maxlength", "9", "formControlName", "extension", "data-automation", "extension", 3, "id", "placeholder", "input"], [3, "value"], ["matInput", "", "maxlength", "80", "formControlName", "address_1", "data-automation", "address_1", 3, "id", "placeholder", "input"], ["matInput", "", "maxlength", "80", "formControlName", "address_2", "data-automation", "address_2", 3, "id", "placeholder", "input"], ["matInput", "", "maxlength", "80", "formControlName", "city", "data-automation", "city", 3, "id", "placeholder", "input"], ["formControlName", "country", "data-automation", "country", 3, "id", "placeholder", "selectionChange"], ["formControlName", "state_province", "data-automation", "state_province", 3, "id", "placeholder", "input"], ["matInput", "", "formControlName", "postal_code", "data-automation", "postal_code", 3, "id", "placeholder", "input"]], template: function EditProfileComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "mat-expansion-panel", 1)(2, "mat-expansion-panel-header", 2)(3, "mat-panel-title");
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 3)(7, "mat-form-field", 4)(8, "mat-label");
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(11, "input", 5);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵtemplate(13, EditProfileComponent_mat_error_13_Template, 3, 3, "mat-error", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "mat-form-field", 4)(15, "mat-label");
            i0.ɵɵtext(16);
            i0.ɵɵpipe(17, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(18, "input", 7);
            i0.ɵɵpipe(19, "translate");
            i0.ɵɵtemplate(20, EditProfileComponent_mat_error_20_Template, 3, 3, "mat-error", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "mat-form-field", 4)(22, "mat-label");
            i0.ɵɵtext(23);
            i0.ɵɵpipe(24, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(25, "input", 8);
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵtemplate(27, EditProfileComponent_mat_error_27_Template, 3, 3, "mat-error", 6);
            i0.ɵɵtemplate(28, EditProfileComponent_mat_error_28_Template, 3, 3, "mat-error", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(29, "mat-form-field", 4)(30, "mat-label");
            i0.ɵɵtext(31);
            i0.ɵɵpipe(32, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(33, "input", 9);
            i0.ɵɵpipe(34, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(35, EditProfileComponent_ng_container_35_Template, 2, 1, "ng-container", 10);
            i0.ɵɵtemplate(36, EditProfileComponent_ng_container_36_Template, 2, 1, "ng-container", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(37, "mat-expansion-panel", 11)(38, "mat-expansion-panel-header", 2)(39, "mat-panel-title");
            i0.ɵɵtext(40);
            i0.ɵɵpipe(41, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(42, "div", 3)(43, "mat-form-field", 4)(44, "mat-label");
            i0.ɵɵtext(45);
            i0.ɵɵpipe(46, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(47, "mat-select", 12);
            i0.ɵɵpipe(48, "translate");
            i0.ɵɵtemplate(49, EditProfileComponent_mat_option_49_Template, 2, 2, "mat-option", 13);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(50, EditProfileComponent_mat_error_50_Template, 3, 3, "mat-error", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(51, "mat-form-field", 4)(52, "mat-label");
            i0.ɵɵtext(53);
            i0.ɵɵpipe(54, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(55, "mat-select", 14);
            i0.ɵɵpipe(56, "translate");
            i0.ɵɵtemplate(57, EditProfileComponent_mat_option_57_Template, 2, 2, "mat-option", 13);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(58, EditProfileComponent_mat_error_58_Template, 3, 3, "mat-error", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(59, "mat-form-field", 4)(60, "mat-label");
            i0.ɵɵtext(61);
            i0.ɵɵpipe(62, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(63, "mat-select", 15);
            i0.ɵɵpipe(64, "translate");
            i0.ɵɵtemplate(65, EditProfileComponent_mat_option_65_Template, 2, 2, "mat-option", 13);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(66, EditProfileComponent_mat_error_66_Template, 3, 3, "mat-error", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(67, "mat-form-field", 4)(68, "mat-label");
            i0.ɵɵtext(69);
            i0.ɵɵpipe(70, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(71, "mat-select", 16);
            i0.ɵɵpipe(72, "translate");
            i0.ɵɵtemplate(73, EditProfileComponent_mat_option_73_Template, 2, 2, "mat-option", 13);
            i0.ɵɵpipe(74, "keyvalue");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(75, EditProfileComponent_mat_error_75_Template, 3, 3, "mat-error", 6);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(76, EditProfileComponent_mat_expansion_panel_76_Template, 4, 0, "mat-expansion-panel", 17);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.userUpdateForm);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("expanded", !ctx.isCommunityUser);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 35, ctx.namespace + "GlobalNav.profile.titles.contact_information"));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 37, ctx.namespace + "GlobalNav.profile.first_name"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(12, 39, ctx.namespace + "GlobalNav.profile.first_name"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.firstName.hasError("required"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 41, ctx.namespace + "GlobalNav.profile.last_name"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(19, 43, ctx.namespace + "GlobalNav.profile.last_name"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.lastName.hasError("required"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 45, ctx.namespace + "GlobalNav.profile.email"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(26, 47, ctx.namespace + "GlobalNav.profile.email"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.email.hasError("required"));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.email.hasError("pattern"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(32, 49, ctx.namespace + "GlobalNav.profile.title"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(34, 51, ctx.namespace + "GlobalNav.profile.title"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.phones.controls);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.addresses.controls);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(41, 53, ctx.namespace + "GlobalNav.profile.titles.user_preferences"));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(46, 55, ctx.namespace + "GlobalNav.profile.locale"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(48, 57, ctx.namespace + "GlobalNav.profile.locale"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.locales);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.defaultLocale.hasError("required"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(54, 59, ctx.namespace + "GlobalNav.profile.timezone"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(56, 61, ctx.namespace + "GlobalNav.profile.timezone"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.timezones);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.defaultTimeZone.hasError("required"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(62, 63, ctx.namespace + "GlobalNav.profile.unit_system"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(64, 65, ctx.namespace + "GlobalNav.profile.unit_system"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.unitSystems);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.defaultUnitSystem.hasError("required"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(70, 67, ctx.namespace + "GlobalNav.profile.home_application"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(72, 69, ctx.namespace + "GlobalNav.profile.home_application"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(74, 71, ctx.applications));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.defaultHomeApplication.hasError("required"));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.userData.preferences.notifications);
        } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.RequiredValidator, i2.MaxLengthValidator, i2.NgModelGroup, i2.FormGroupDirective, i2.FormControlName, i5$1.MatExpansionPanel, i5$1.MatExpansionPanelHeader, i5$1.MatExpansionPanelTitle, i6$1.MatFormField, i6$1.MatLabel, i6$1.MatError, i7$1.MatSelect, i8$1.MatOption, i9.MatInput, i1$2.KeyValuePipe, i5.TranslatePipe], styles: ["#userUpdate[_ngcontent-%COMP%]   .panel-content[_ngcontent-%COMP%]{padding:30px 20px 20px}", "input[_ngcontent-%COMP%]:focus, input[_ngcontent-%COMP%]:active, input[_ngcontent-%COMP%]:hover, select[_ngcontent-%COMP%]:focus, select[_ngcontent-%COMP%]:active, select[_ngcontent-%COMP%]:hover, textarea[_ngcontent-%COMP%]:focus, textarea[_ngcontent-%COMP%]:active, textarea[_ngcontent-%COMP%]:hover{border:none}.mat-mdc-form-field[_ngcontent-%COMP%]{width:100%}.mat-expansion-panel-header[_ngcontent-%COMP%]{background:var(--row-highlight);border-top:solid 1px var(--row-highlight-hover);border-bottom:solid 1px var(--row-highlight-hover);border-radius:0;padding-left:40px}.mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]:hover, .mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]:focus{background:var(--row-highlight)}.mat-expansion-panel-header-title[_ngcontent-%COMP%]{color:var(--primary-color);letter-spacing:.5px}.circle[_ngcontent-%COMP%]{background:var(--accent-color);color:#fff;border-radius:32px;height:30px;width:30px;text-align:center;line-height:32px;padding-left:1px;font-weight:700}  .mat-mdc-dialog-container{background-color:#fff!important}  .mat-expansion-panel-header{font-family:var(--fonts)!important}  .mat-expansion-panel-content{font-family:var(--fonts)!important}.mat-mdc-form-field-error[_ngcontent-%COMP%]{color:red}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditProfileComponent, [{
        type: Component,
        args: [{ selector: 'app-edit-profile', viewProviders: [{ provide: ControlContainer, useExisting: NgForm }], template: "<div ngModelGroup=\"app-edit-profile\" id=\"userUpdate\" [formGroup]=\"userUpdateForm\">\r\n  <mat-expansion-panel togglePosition=\"after\" [expanded]=\"!isCommunityUser\">\r\n  <mat-expansion-panel-header collapsedHeight=\"42px\" expandedHeight=\"42px\">\r\n    <mat-panel-title>{{ namespace + 'GlobalNav.profile.titles.contact_information' | translate }}</mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <div class=\"panel-content\">\r\n    <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n      <mat-label>{{ namespace + 'GlobalNav.profile.first_name' | translate }}</mat-label>\r\n      <input\r\n        id=\"first_name\"\r\n        matInput\r\n        maxlength=\"80\"\r\n        required\r\n        placeholder=\"{{ namespace + 'GlobalNav.profile.first_name' | translate }}\"\r\n        formControlName=\"first_name\"\r\n        data-automation=\"first_name\"\r\n      />\r\n      <mat-error *ngIf=\"firstName.hasError('required')\">\r\n        {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n      </mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n      <mat-label>{{ namespace + 'GlobalNav.profile.last_name' | translate }}</mat-label>\r\n      <input\r\n        id=\"last_name\"\r\n        matInput\r\n        maxlength=\"80\"\r\n        required\r\n        placeholder=\"{{ namespace + 'GlobalNav.profile.last_name' | translate }}\"\r\n        formControlName=\"last_name\"\r\n        data-automation=\"last_name\"\r\n      />\r\n      <mat-error *ngIf=\"lastName.hasError('required')\">\r\n        {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n      </mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n      <mat-label>{{ namespace + 'GlobalNav.profile.email' | translate }}</mat-label>\r\n      <input\r\n        id=\"email\"\r\n        matInput\r\n        required\r\n        maxlength=\"80\"\r\n        placeholder=\"{{ namespace + 'GlobalNav.profile.email' | translate }}\"\r\n        formControlName=\"email\"\r\n        data-automation=\"email\"\r\n      />\r\n      <mat-error *ngIf=\"email.hasError('required')\">\r\n        {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n      </mat-error>\r\n      <mat-error *ngIf=\"email.hasError('pattern')\">\r\n        {{ namespace + 'GlobalNav.errors.invalid_email' | translate }}\r\n      </mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n      <mat-label>{{ namespace + 'GlobalNav.profile.title' | translate }}</mat-label>\r\n      <input\r\n        id=\"title\"\r\n        matInput\r\n        maxlength=\"80\"\r\n        placeholder=\"{{ namespace + 'GlobalNav.profile.title' | translate }}\"\r\n        formControlName=\"title\"\r\n        data-automation=\"title\"\r\n      />\r\n    </mat-form-field>\r\n\r\n    <ng-container *ngFor=\"let phone of phones.controls; let phoneIndex = index\">\r\n      <ng-container [formGroup]=\"getFormGroupFromAbstractControl(phone)\" *ngIf=\"phone.get('primary')?.value\">\r\n        <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n          <mat-label>{{ namespace + 'GlobalNav.profile.country_code' | translate }}</mat-label>\r\n          <mat-select\r\n            id=\"country_code_{{phoneIndex}}\"\r\n            (selectionChange)=\"onPhoneFieldChange()\"\r\n            formControlName=\"country_code\"\r\n            data-automation=\"country_code\"\r\n            placeholder=\"{{\r\n                            (hasAnyPhoneField\r\n                                ? namespace + 'GlobalNav.profile.placeholder.country_code_required'\r\n                                : namespace + 'GlobalNav.profile.placeholder.country_code'\r\n                            ) | translate\r\n                        }}\"\r\n          >\r\n            <mat-option>{{ namespace + 'GlobalNav.profile.placeholder.country_code' | translate }}</mat-option>\r\n            <mat-option *ngFor=\"let callingCode of callingCodes\" [value]=\"callingCode.code\">\r\n              +{{ callingCode.code }} {{ callingCode.country }}\r\n            </mat-option>\r\n          </mat-select>\r\n          <mat-error *ngIf=\"phone.get('country_code')?.hasError('required')\">\r\n            {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n          </mat-error>\r\n        </mat-form-field>\r\n\r\n        <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n          <mat-label>{{ namespace + 'GlobalNav.profile.phone_number' | translate }}</mat-label>\r\n          <input\r\n            id=\"phone_number_{{phoneIndex}}\"\r\n            matInput\r\n            (input)=\"onPhoneFieldChange()\"\r\n            placeholder=\"{{\r\n                            (hasAnyPhoneField\r\n                                ? namespace + 'GlobalNav.profile.placeholder.phone_number_required'\r\n                                : namespace + 'GlobalNav.profile.placeholder.phone_number'\r\n                            ) | translate\r\n                        }}\"\r\n            formControlName=\"phone_number\"\r\n            data-automation=\"phone_number\"\r\n          />\r\n          <mat-error *ngIf=\"phone.get('phone_number')?.hasError('required')\">\r\n            {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n          </mat-error>\r\n        </mat-form-field>\r\n\r\n        <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n          <mat-label>{{ namespace + 'GlobalNav.profile.extension' | translate }}</mat-label>\r\n          <input\r\n            id=\"extension_{{phoneIndex}}\"\r\n            (input)=\"onPhoneFieldChange()\"\r\n            matInput\r\n            maxlength=\"9\"\r\n            placeholder=\"{{ namespace + 'GlobalNav.profile.placeholder.extension' | translate }}\"\r\n            formControlName=\"extension\"\r\n            data-automation=\"extension\"\r\n          />\r\n        </mat-form-field>\r\n        <mat-error *ngIf=\"phone.get('extension')?.hasError('required')\">\r\n          {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n        </mat-error>\r\n      </ng-container>\r\n    </ng-container>\r\n\r\n    <ng-container *ngFor=\"let address of addresses.controls; let addressIndex = index\">\r\n      <ng-container [formGroup]=\"getFormGroupFromAbstractControl(address)\" *ngIf=\"address.get('primary')?.value\">\r\n        <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n          <mat-label>{{ namespace + 'GlobalNav.profile.address_1' | translate }}</mat-label>\r\n          <input\r\n            id=\"address_1_{{addressIndex}}\"\r\n            (input)=\"onAddressFieldChange()\"\r\n            matInput\r\n            maxlength=\"80\"\r\n            placeholder=\"{{\r\n                            (hasAnyAddressField\r\n                                ? namespace + 'GlobalNav.profile.placeholder.address1_required'\r\n                                : namespace + 'GlobalNav.profile.placeholder.address1'\r\n                            ) | translate\r\n                        }}\"\r\n            formControlName=\"address_1\"\r\n            data-automation=\"address_1\"\r\n          />\r\n          <mat-error *ngIf=\"address.get('address_1')?.hasError('required')\">\r\n            {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n          </mat-error>\r\n        </mat-form-field>\r\n\r\n        <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n          <mat-label>{{ namespace + 'GlobalNav.profile.address_2' | translate }}</mat-label>\r\n          <input\r\n            id=\"address_2_{{addressIndex}}\"\r\n            (input)=\"onAddressFieldChange()\"\r\n            matInput\r\n            maxlength=\"80\"\r\n            placeholder=\"{{ namespace + 'GlobalNav.profile.placeholder.address2' | translate }}\"\r\n            formControlName=\"address_2\"\r\n            data-automation=\"address_2\"\r\n          />\r\n        </mat-form-field>\r\n\r\n        <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n          <mat-label>{{ namespace + 'GlobalNav.profile.city' | translate }}</mat-label>\r\n          <input\r\n            id=\"city_{{addressIndex}}\"\r\n            (input)=\"onAddressFieldChange()\"\r\n            matInput\r\n            maxlength=\"80\"\r\n            placeholder=\"{{\r\n                            (hasAnyAddressField\r\n                                ? namespace + 'GlobalNav.profile.placeholder.city_required'\r\n                                : namespace + 'GlobalNav.profile.placeholder.city'\r\n                            ) | translate\r\n                         }}\"\r\n            formControlName=\"city\"\r\n            data-automation=\"city\"\r\n          />\r\n          <mat-error *ngIf=\"address.get('city')?.hasError('required')\">\r\n            {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n          </mat-error>\r\n        </mat-form-field>\r\n\r\n        <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n          <mat-label>{{ namespace + 'GlobalNav.profile.country' | translate }}</mat-label>\r\n          <mat-select\r\n            id=\"country_{{addressIndex}}\"\r\n            formControlName=\"country\"\r\n            data-automation=\"country\"\r\n            placeholder=\"{{\r\n                            (hasAnyAddressField\r\n                                ? namespace + 'GlobalNav.profile.placeholder.country_selector_required'\r\n                                : namespace + 'GlobalNav.profile.placeholder.country_selector'\r\n                            ) | translate\r\n                         }}\"\r\n            (selectionChange)=\"onCountryChange($event)\"\r\n          >\r\n            <mat-option>{{ namespace + 'GlobalNav.profile.placeholder.country_selector' | translate }}</mat-option>\r\n            <mat-option *ngFor=\"let country of countries\" [value]=\"country.name\">\r\n              {{ country.display_label }}\r\n            </mat-option>\r\n          </mat-select>\r\n          <mat-error *ngIf=\"address.get('country')?.hasError('required')\">\r\n            {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n          </mat-error>\r\n        </mat-form-field>\r\n\r\n        <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n          <mat-label>{{ namespace + 'GlobalNav.profile.state_province' | translate }}</mat-label>\r\n          <mat-select\r\n            id=\"state_province_{{addressIndex}}\"\r\n            (input)=\"onAddressFieldChange()\"\r\n            formControlName=\"state_province\"\r\n            data-automation=\"state_province\"\r\n            placeholder=\"{{\r\n                            (hasAnyAddressField\r\n                                ? namespace + 'GlobalNav.profile.placeholder.state_selector_required'\r\n                                : namespace + 'GlobalNav.profile.placeholder.state_selector'\r\n                            ) | translate\r\n                        }}\"\r\n          >\r\n            <mat-option>{{ namespace + 'GlobalNav.profile.placeholder.state_selector' | translate }}</mat-option>\r\n            <mat-option *ngFor=\"let state of states\" [value]=\"state.name\">\r\n              {{ state.display_label}}\r\n            </mat-option>\r\n          </mat-select>\r\n          <mat-error *ngIf=\"address.get('state_province')?.hasError('required')\">\r\n            {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n          </mat-error>\r\n        </mat-form-field>\r\n\r\n        <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n          <mat-label>{{ namespace + 'GlobalNav.profile.postal_code' | translate }}</mat-label>\r\n          <input\r\n            id=\"postal_code_{{addressIndex}}\"\r\n            matInput\r\n            (input)=\"onAddressFieldChange()\"\r\n            placeholder=\"{{\r\n                            (hasAnyAddressField\r\n                                ? namespace + 'GlobalNav.profile.placeholder.zip_required'\r\n                                : namespace + 'GlobalNav.profile.placeholder.zip'\r\n                            ) | translate\r\n                        }}\"\r\n            formControlName=\"postal_code\"\r\n            data-automation=\"postal_code\"\r\n          />\r\n          <mat-error *ngIf=\"address.get('postal_code')?.hasError('required')\">\r\n            {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n          </mat-error>\r\n        </mat-form-field>\r\n      </ng-container>\r\n    </ng-container>\r\n  </div>\r\n  </mat-expansion-panel>\r\n  <mat-expansion-panel togglePosition=\"after\" expanded=\"true\">\r\n    <mat-expansion-panel-header collapsedHeight=\"42px\" expandedHeight=\"42px\">\r\n      <mat-panel-title>{{ namespace + 'GlobalNav.profile.titles.user_preferences' | translate }}</mat-panel-title>\r\n    </mat-expansion-panel-header>\r\n    <div class=\"panel-content\">\r\n      <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n        <mat-label>{{ namespace + 'GlobalNav.profile.locale' | translate }}</mat-label>\r\n        <mat-select\r\n          required\r\n          formControlName=\"locale\"\r\n          data-automation=\"locale\"\r\n          placeholder=\"{{ namespace + 'GlobalNav.profile.locale' | translate }}\"\r\n        >\r\n          <mat-option *ngFor=\"let locale of locales\" [value]=\"locale.locale_name\">\r\n            {{ locale.display_label }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"defaultLocale.hasError('required')\">\r\n          {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n        </mat-error>\r\n      </mat-form-field>\r\n\r\n      <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n        <mat-label>{{ namespace + 'GlobalNav.profile.timezone' | translate }}</mat-label>\r\n        <mat-select\r\n          required\r\n          formControlName=\"timezone\"\r\n          data-automation=\"locale\"\r\n          placeholder=\"{{ namespace + 'GlobalNav.profile.timezone' | translate }}\"\r\n        >\r\n          <mat-option *ngFor=\"let timezone of timezones\" [value]=\"timezone.timezone_name\">\r\n            {{ timezone.display_label }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"defaultTimeZone.hasError('required')\">\r\n          {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n        </mat-error>\r\n      </mat-form-field>\r\n\r\n      <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n        <mat-label>{{ namespace + 'GlobalNav.profile.unit_system' | translate }}</mat-label>\r\n        <mat-select\r\n          required\r\n          formControlName=\"unit_system\"\r\n          data-automation=\"unit_system\"\r\n          placeholder=\"{{ namespace + 'GlobalNav.profile.unit_system' | translate }}\"\r\n        >\r\n          <mat-option *ngFor=\"let unitSystem of unitSystems\" [value]=\"unitSystem.id\">\r\n            {{ unitSystem.display_label }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"defaultUnitSystem.hasError('required')\">\r\n          {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n        </mat-error>\r\n      </mat-form-field>\r\n\r\n      <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n        <mat-label>{{ namespace + 'GlobalNav.profile.home_application' | translate }}</mat-label>\r\n        <mat-select\r\n          required\r\n          formControlName=\"home_application\"\r\n          data-automation=\"home_application\"\r\n          placeholder=\"{{ namespace + 'GlobalNav.profile.home_application' | translate }}\"\r\n        >\r\n          <mat-option *ngFor=\"let application of applications | keyvalue\" [value]=\"applications[application.key].name\">\r\n            {{ applications[application.key].display_label }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"defaultHomeApplication.hasError('required')\">\r\n          {{ namespace + 'GlobalNav.errors.required' | translate }}\r\n        </mat-error>\r\n      </mat-form-field>\r\n    </div>\r\n  </mat-expansion-panel>\r\n  <mat-expansion-panel togglePosition=\"after\" expanded=\"true\" *ngIf=\"userData.preferences.notifications\">\r\n    <mat-expansion-panel-header collapsedHeight=\"42px\" expandedHeight=\"42px\">\r\n      <mat-panel-title>Notification Settings</mat-panel-title>\r\n    </mat-expansion-panel-header>\r\n  </mat-expansion-panel>\r\n</div>\r\n", styles: ["#userUpdate .panel-content{padding:30px 20px 20px}\n", "input:focus,input:active,input:hover,select:focus,select:active,select:hover,textarea:focus,textarea:active,textarea:hover{border:none}.mat-mdc-form-field{width:100%}.mat-expansion-panel-header{background:var(--row-highlight);border-top:solid 1px var(--row-highlight-hover);border-bottom:solid 1px var(--row-highlight-hover);border-radius:0;padding-left:40px}.mat-expansion-panel-header.mat-expanded:hover,.mat-expansion-panel-header.mat-expanded:focus{background:var(--row-highlight)}.mat-expansion-panel-header-title{color:var(--primary-color);letter-spacing:.5px}.circle{background:var(--accent-color);color:#fff;border-radius:32px;height:30px;width:30px;text-align:center;line-height:32px;padding-left:1px;font-weight:700}::ng-deep .mat-mdc-dialog-container{background-color:#fff!important}::ng-deep .mat-expansion-panel-header{font-family:var(--fonts)!important}::ng-deep .mat-expansion-panel-content{font-family:var(--fonts)!important}.mat-mdc-form-field-error{color:red}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [NAMESPACE_TOKEN]
            }] }, { type: ProfileService }, { type: i2.FormBuilder }, { type: GlobalNavService }]; }, { userUpdateForm: [{
            type: Input
        }] }); })();

/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | phoneNumber
 * Example:
 *   {{ '5555555555' | phoneNumber }}
 *   formats to: 555-555-5555
 */
class PhoneNumberPipe {
    transform(phoneNumber) {
        if (!phoneNumber) {
            return '';
        }
        phoneNumber = phoneNumber.replace(/[^0-9]+/g, '');
        let countryCode = '';
        let start = 0;
        if (phoneNumber.length > 10) {
            countryCode = `+${phoneNumber.slice(0, 1)} `;
            start++;
        }
        let extension = '';
        if (phoneNumber.length > 11) {
            extension = ` ext ${phoneNumber.slice(start + 10, start + 16)}`;
        }
        if (phoneNumber.length < 4) {
            return `${phoneNumber}`;
        }
        if (phoneNumber.length < 7) {
            return `${phoneNumber.slice(start, start + 3)}-${phoneNumber.slice(start + 3, start + 6)}`;
        }
        return `${countryCode}${phoneNumber.slice(start, start + 3)}-${phoneNumber.slice(start + 3, start + 6)}-${phoneNumber.slice(start + 6, start + 10)}${extension}`;
    }
    static { this.ɵfac = function PhoneNumberPipe_Factory(t) { return new (t || PhoneNumberPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "phoneNumber", type: PhoneNumberPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PhoneNumberPipe, [{
        type: Pipe,
        args: [{ name: 'phoneNumber' }]
    }], null, null); })();

function ViewProfileComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx_r0.namespace + "GlobalNav.profile.title"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.userData.title || "");
} }
function ViewProfileComponent_div_19_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("+", ctx_r6.primaryPhone.country_code, "");
} }
function ViewProfileComponent_div_19_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(ext ", ctx_r7.primaryPhone.extension, ")");
} }
function ViewProfileComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵtemplate(5, ViewProfileComponent_div_19_span_5_Template, 2, 1, "span", 8);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "phoneNumber");
    i0.ɵɵtemplate(8, ViewProfileComponent_div_19_span_8_Template, 2, 1, "span", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, ctx_r1.namespace + "GlobalNav.profile.phone_number"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.primaryPhone.country_code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 6, ctx_r1.primaryPhone.phone_number), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.primaryPhone.extension);
} }
function ViewProfileComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 5);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 5);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 5);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 6, ctx_r2.namespace + "GlobalNav.profile.address"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.primaryAddress.address_1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.primaryAddress.address_2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.primaryAddress.city);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.primaryAddress.state_province);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.primaryAddress.postal_code);
} }
function ViewProfileComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx_r3.namespace + "GlobalNav.profile.ecrm_id"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.userData.ecrm_id || "");
} }
function ViewProfileComponent_mat_expansion_panel_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-expansion-panel", 0)(1, "mat-expansion-panel-header", 1)(2, "mat-panel-title");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 2)(6, "div", 3)(7, "div", 4);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 5);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 3)(13, "div", 4);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 5);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "div", 3)(19, "div", 4);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 5);
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 3)(25, "div", 4);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 5);
    i0.ɵɵtext(29);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 9, ctx_r4.namespace + "GlobalNav.profile.titles.user_preferences"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 11, ctx_r4.namespace + "GlobalNav.profile.locale"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.getDefaultLocale());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 13, ctx_r4.namespace + "GlobalNav.profile.timezone"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.getDefaultTimeZone());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 15, ctx_r4.namespace + "GlobalNav.profile.unit_system"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.getUnitSystem());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 17, ctx_r4.namespace + "GlobalNav.profile.home_application"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.getHomeApplication());
} }
function ViewProfileComponent_mat_expansion_panel_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-expansion-panel", 0)(1, "mat-expansion-panel-header", 1)(2, "mat-panel-title");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, ctx_r5.namespace + "GlobalNav.profile.titles.notification_settings"));
} }
class ViewProfileComponent {
    constructor(namespace = '', profileService, globalNavService, changeDetectorRef) {
        this.namespace = namespace;
        this.profileService = profileService;
        this.globalNavService = globalNavService;
        this.changeDetectorRef = changeDetectorRef;
        this.countries = [];
        this.timezones = [];
        this.locales = [];
        this.unitSystems = [];
        this.applications = [];
        this.isCommunityUser = false;
        this.federated_applications = [];
        this.userData = null;
        this.metadata = null;
        this.selectedCountry = {};
        this.primaryEmail = {
            email_address: '',
            email_type: 'WORK',
            primary: true,
        };
        this.primaryAddress = {
            address_1: '',
            address_2: '',
            city: '',
            country: '',
            state_province: '',
            postal_code: 0,
            address_type: 'PO_BOX',
            primary: true,
        };
        this.primaryPhone = {
            phone_number: '',
            phone_type: 'WORK',
            primary: true,
            extension: 0,
            country_code: 0,
        };
        this.globalNavService.userData$.subscribe((userData) => {
            if (userData) {
                this.userData = userData;
                this.setPrimaryInfo();
            }
        });
        this.globalNavService.userRolesList$.subscribe((userRoles) => {
            if (userRoles) {
                if (userRoles.length > 0) {
                    this.isCommunityUser = userRoles.some((role) => role.business_role == 'COMMUNITY_USER');
                    if (this.isCommunityUser &&
                        this.userData.federated_applications &&
                        this.userData.federated_applications.length > 0) {
                        let ecrmApp = this.userData.federated_applications.find((app) => app.application_name === 'ECRM_SSO');
                        this.userData.ecrm_id = ecrmApp?.username;
                    }
                    this.setPrimaryInfo();
                }
            }
        });
        this.globalNavService.metaData$.subscribe((metadata) => {
            if (metadata) {
                this.metadata = metadata;
                const { applications, countries, locales, timezones, unit_systems } = metadata;
                this.unitSystems = unit_systems;
                this.applications = applications;
                this.countries = countries;
                this.locales = locales;
                this.timezones = timezones;
                this.setPrimaryInfo();
            }
        });
    }
    getDefaultTimeZone() {
        let timeZoneName = '';
        if (this.timezones && this.timezones.length > 0 && this.userData && this.userData.preferences) {
            const foundTimeZone = this.timezones.find((timezone) => timezone.timezone_name === this.userData.preferences.default_time_zone);
            if (foundTimeZone) {
                timeZoneName = foundTimeZone.display_label;
            }
        }
        return timeZoneName;
    }
    getDefaultLocale() {
        let localeName = '';
        if (this.locales && this.locales.length > 0 && this.userData && this.userData.preferences) {
            const foundLocale = this.locales.find((locale) => locale.locale_name === this.userData.preferences.default_locale);
            if (foundLocale) {
                localeName = foundLocale.display_label;
            }
        }
        return localeName;
    }
    getUnitSystem() {
        let unitSystemName = '';
        if (this.unitSystems && this.unitSystems.length > 0 && this.userData && this.userData.preferences) {
            const foundUnit = this.unitSystems.find((unitSystem) => unitSystem.id === this.userData.preferences.default_unit_system);
            if (foundUnit) {
                unitSystemName = foundUnit.display_label;
            }
        }
        return unitSystemName;
    }
    getHomeApplication() {
        if (this.applications && this.userData && this.userData.preferences) {
            const applicationName = this.userData.preferences.default_page;
            if (this.applications[applicationName]) {
                return this.applications[applicationName].display_label;
            }
        }
        return '';
    }
    setPrimaryInfo() {
        if (this.userData && this.userData.profile && this.metadata) {
            this.primaryEmail = this.profileService.getPrimaryData(this.userData.profile.contact_details.emails);
            this.primaryAddress = this.profileService.getPrimaryData(this.userData.profile.contact_details.addresses);
            this.primaryPhone = this.profileService.getPrimaryData(this.userData.profile.contact_details.phones);
            this.changeDetectorRef.markForCheck();
        }
    }
    static { this.ɵfac = function ViewProfileComponent_Factory(t) { return new (t || ViewProfileComponent)(i0.ɵɵdirectiveInject(NAMESPACE_TOKEN), i0.ɵɵdirectiveInject(ProfileService), i0.ɵɵdirectiveInject(GlobalNavService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ViewProfileComponent, selectors: [["app-view-profile"]], decls: 24, vars: 17, consts: [["togglePosition", "after", "expanded", "true"], ["collapsedHeight", "42px", "expandedHeight", "42px"], [1, "panel-content"], [1, "field-wrapper"], [1, "user-label"], [1, "user-text"], ["class", "field-wrapper", 4, "ngIf"], ["togglePosition", "after", "expanded", "true", 4, "ngIf"], [4, "ngIf"], ["data-automation", "ecrm-field", 1, "user-text"]], template: function ViewProfileComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-expansion-panel", 0)(1, "mat-expansion-panel-header", 1)(2, "mat-panel-title");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 2)(6, "div", 3)(7, "div", 4);
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 5);
            i0.ɵɵtext(11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 3)(13, "div", 4);
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "div", 5);
            i0.ɵɵtext(17);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(18, ViewProfileComponent_div_18_Template, 6, 4, "div", 6);
            i0.ɵɵtemplate(19, ViewProfileComponent_div_19_Template, 9, 8, "div", 6);
            i0.ɵɵtemplate(20, ViewProfileComponent_div_20_Template, 14, 8, "div", 6);
            i0.ɵɵtemplate(21, ViewProfileComponent_div_21_Template, 6, 4, "div", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(22, ViewProfileComponent_mat_expansion_panel_22_Template, 30, 19, "mat-expansion-panel", 7);
            i0.ɵɵtemplate(23, ViewProfileComponent_mat_expansion_panel_23_Template, 5, 3, "mat-expansion-panel", 7);
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 11, ctx.namespace + "GlobalNav.profile.titles.contact_information"));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 13, ctx.namespace + "GlobalNav.profile.username"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.userData.username);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 15, ctx.namespace + "GlobalNav.profile.email"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.primaryEmail.email_address);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.userData.title);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.primaryPhone && ctx.primaryPhone.phone_number);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.primaryAddress && ctx.primaryAddress.address_1);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.userData.ecrm_id);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.userData.preferences);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.userData.preferences && ctx.userData.preferences.notifications);
        } }, dependencies: [i1$2.NgIf, i5$1.MatExpansionPanel, i5$1.MatExpansionPanelHeader, i5$1.MatExpansionPanelTitle, i5.TranslatePipe, PhoneNumberPipe], styles: [".user-label[_ngcontent-%COMP%]{color:#777;font-size:14px;line-height:26px;font-weight:500}.user-text[_ngcontent-%COMP%]{color:#999;line-height:23px;padding-left:20px;margin-bottom:15px}.panel-content[_ngcontent-%COMP%]{padding:10px 20px;display:flex;flex-direction:column}", "input[_ngcontent-%COMP%]:focus, input[_ngcontent-%COMP%]:active, input[_ngcontent-%COMP%]:hover, select[_ngcontent-%COMP%]:focus, select[_ngcontent-%COMP%]:active, select[_ngcontent-%COMP%]:hover, textarea[_ngcontent-%COMP%]:focus, textarea[_ngcontent-%COMP%]:active, textarea[_ngcontent-%COMP%]:hover{border:none}.mat-mdc-form-field[_ngcontent-%COMP%]{width:100%}.mat-expansion-panel-header[_ngcontent-%COMP%]{background:var(--row-highlight);border-top:solid 1px var(--row-highlight-hover);border-bottom:solid 1px var(--row-highlight-hover);border-radius:0;padding-left:40px}.mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]:hover, .mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]:focus{background:var(--row-highlight)}.mat-expansion-panel-header-title[_ngcontent-%COMP%]{color:var(--primary-color);letter-spacing:.5px}.circle[_ngcontent-%COMP%]{background:var(--accent-color);color:#fff;border-radius:32px;height:30px;width:30px;text-align:center;line-height:32px;padding-left:1px;font-weight:700}  .mat-mdc-dialog-container{background-color:#fff!important}  .mat-expansion-panel-header{font-family:var(--fonts)!important}  .mat-expansion-panel-content{font-family:var(--fonts)!important}.mat-mdc-form-field-error[_ngcontent-%COMP%]{color:red}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ViewProfileComponent, [{
        type: Component,
        args: [{ selector: 'app-view-profile', template: "<mat-expansion-panel togglePosition=\"after\" expanded=\"true\">\r\n  <mat-expansion-panel-header collapsedHeight=\"42px\" expandedHeight=\"42px\">\r\n    <mat-panel-title>{{ namespace + 'GlobalNav.profile.titles.contact_information' | translate }}</mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <div class=\"panel-content\">\r\n    <div class=\"field-wrapper\">\r\n      <div class=\"user-label\">{{ namespace + 'GlobalNav.profile.username' | translate }}</div>\r\n      <div class=\"user-text\">{{userData.username}}</div>\r\n    </div>\r\n\r\n    <div class=\"field-wrapper\">\r\n      <div class=\"user-label\">{{ namespace + 'GlobalNav.profile.email' | translate }}</div>\r\n      <div class=\"user-text\">{{ primaryEmail.email_address }}</div>\r\n    </div>\r\n\r\n    <div class=\"field-wrapper\" *ngIf=\"userData.title\">\r\n      <div class=\"user-label\">{{ namespace + 'GlobalNav.profile.title' | translate }}</div>\r\n      <div class=\"user-text\">{{ userData.title || '' }}</div>\r\n    </div>\r\n\r\n    <div class=\"field-wrapper\" *ngIf=\"primaryPhone && primaryPhone.phone_number\">\r\n      <div class=\"user-label\">{{ namespace + 'GlobalNav.profile.phone_number' | translate }}</div>\r\n      <div class=\"user-text\">\r\n        <span *ngIf=\"primaryPhone.country_code\">+{{ primaryPhone.country_code }}</span>\r\n        {{ primaryPhone.phone_number | phoneNumber }}\r\n        <span *ngIf=\"primaryPhone.extension\">(ext {{ primaryPhone.extension }})</span>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"field-wrapper\" *ngIf=\"primaryAddress && primaryAddress.address_1\">\r\n      <div class=\"user-label\">{{ namespace + 'GlobalNav.profile.address' | translate }}</div>\r\n      <div class=\"user-text\">{{ primaryAddress.address_1 }}</div>\r\n      <div class=\"user-text\">{{ primaryAddress.address_2 }}</div>\r\n      <div class=\"user-text\">{{ primaryAddress.city }}</div>\r\n      <div class=\"user-text\">{{ primaryAddress.state_province }}</div>\r\n      <div class=\"user-text\">{{ primaryAddress.postal_code }}</div>\r\n    </div>\r\n    <div class=\"field-wrapper\" *ngIf=\"userData.ecrm_id\">\r\n      <div class=\"user-label\">{{ namespace + 'GlobalNav.profile.ecrm_id' | translate }}</div>\r\n      <div class=\"user-text\" data-automation=\"ecrm-field\">{{ userData.ecrm_id || '' }}</div>\r\n    </div>\r\n  </div>\r\n</mat-expansion-panel>\r\n<mat-expansion-panel togglePosition=\"after\" expanded=\"true\" *ngIf=\"userData.preferences\">\r\n  <mat-expansion-panel-header collapsedHeight=\"42px\" expandedHeight=\"42px\">\r\n    <mat-panel-title>{{ namespace + 'GlobalNav.profile.titles.user_preferences' | translate }}</mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <div class=\"panel-content\">\r\n    <div class=\"field-wrapper\">\r\n      <div class=\"user-label\">{{ namespace + 'GlobalNav.profile.locale' | translate }}</div>\r\n      <div class=\"user-text\">{{ getDefaultLocale() }}</div>\r\n    </div>\r\n    <div class=\"field-wrapper\">\r\n      <div class=\"user-label\">{{ namespace + 'GlobalNav.profile.timezone' | translate }}</div>\r\n      <div class=\"user-text\">{{ getDefaultTimeZone() }}</div>\r\n    </div>\r\n    <div class=\"field-wrapper\">\r\n      <div class=\"user-label\">{{ namespace + 'GlobalNav.profile.unit_system' | translate }}</div>\r\n      <div class=\"user-text\">{{ getUnitSystem()}}</div>\r\n    </div>\r\n    <div class=\"field-wrapper\">\r\n      <div class=\"user-label\">{{ namespace + 'GlobalNav.profile.home_application' | translate }}</div>\r\n      <div class=\"user-text\">{{ getHomeApplication() }}</div>\r\n    </div>\r\n  </div>\r\n</mat-expansion-panel>\r\n<mat-expansion-panel togglePosition=\"after\" expanded=\"true\" *ngIf=\"userData.preferences && userData.preferences.notifications\">\r\n  <mat-expansion-panel-header collapsedHeight=\"42px\" expandedHeight=\"42px\">\r\n    <mat-panel-title>{{ namespace + 'GlobalNav.profile.titles.notification_settings' | translate }}</mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n</mat-expansion-panel>\r\n", styles: [".user-label{color:#777;font-size:14px;line-height:26px;font-weight:500}.user-text{color:#999;line-height:23px;padding-left:20px;margin-bottom:15px}.panel-content{padding:10px 20px;display:flex;flex-direction:column}\n", "input:focus,input:active,input:hover,select:focus,select:active,select:hover,textarea:focus,textarea:active,textarea:hover{border:none}.mat-mdc-form-field{width:100%}.mat-expansion-panel-header{background:var(--row-highlight);border-top:solid 1px var(--row-highlight-hover);border-bottom:solid 1px var(--row-highlight-hover);border-radius:0;padding-left:40px}.mat-expansion-panel-header.mat-expanded:hover,.mat-expansion-panel-header.mat-expanded:focus{background:var(--row-highlight)}.mat-expansion-panel-header-title{color:var(--primary-color);letter-spacing:.5px}.circle{background:var(--accent-color);color:#fff;border-radius:32px;height:30px;width:30px;text-align:center;line-height:32px;padding-left:1px;font-weight:700}::ng-deep .mat-mdc-dialog-container{background-color:#fff!important}::ng-deep .mat-expansion-panel-header{font-family:var(--fonts)!important}::ng-deep .mat-expansion-panel-content{font-family:var(--fonts)!important}.mat-mdc-form-field-error{color:red}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [NAMESPACE_TOKEN]
            }] }, { type: ProfileService }, { type: GlobalNavService }, { type: i0.ChangeDetectorRef }]; }, null); })();

function ProfileComponent_a_10_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 16);
    i0.ɵɵlistener("click", function ProfileComponent_a_10_Template_a_click_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.editMode($event)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "mat-icon", 17);
    i0.ɵɵtext(3, "edit");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, ctx_r0.namespace + "GlobalNav.buttons.edit_profile"));
} }
function ProfileComponent_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 16);
    i0.ɵɵlistener("click", function ProfileComponent_a_11_Template_a_click_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.viewMode($event)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "+");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, ctx_r1.namespace + "GlobalNav.buttons.cancel"));
} }
function ProfileComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function ProfileComponent_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.handleSubmit()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "done");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 2, ctx_r2.namespace + "GlobalNav.buttons.submit"));
    i0.ɵɵproperty("disabled", ctx_r2.userUpdateForm.pristine || !ctx_r2.userUpdateForm.valid);
} }
function ProfileComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "mat-spinner", 20);
    i0.ɵɵelementEnd();
} }
function ProfileComponent_div_14_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function ProfileComponent_div_14_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r19); const utility_r15 = i0.ɵɵnextContext().$implicit; const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.goTo(utility_r15.customerLink)); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, ctx_r16.namespace + "GlobalNav.buttons.authorize"));
} }
function ProfileComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "div")(2, "mat-icon");
    i0.ɵɵtext(3, "warning_amber");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 22);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, ProfileComponent_div_14_button_8_Template, 4, 3, "button", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const utility_r15 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(6, 3, ctx_r4.namespace + "GlobalNav.profile.authorize_banner"), " ", i0.ɵɵpipeBind1(7, 5, utility_r15.label), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", utility_r15.customerLink.link);
} }
function ProfileComponent_app_view_profile_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "app-view-profile");
} }
function ProfileComponent_form_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "form", null, 25);
    i0.ɵɵelement(2, "app-edit-profile", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("userUpdateForm", ctx_r6.userUpdateForm);
} }
function ProfileComponent_button_18_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function ProfileComponent_button_18_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.goTo(ctx_r21.myAccountLink)); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "person");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 1, ctx_r7.namespace + "GlobalNav.buttons.my_account"));
} }
function ProfileComponent_button_19_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function ProfileComponent_button_19_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.goTo(ctx_r23.profileLink)); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "person");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r8.profileLink.label);
} }
class ProfileComponent {
    constructor(namespace = '', profileService, globalNavService, globalAlertService, translate, cookieService, changeDetectorRef) {
        this.namespace = namespace;
        this.profileService = profileService;
        this.globalNavService = globalNavService;
        this.globalAlertService = globalAlertService;
        this.translate = translate;
        this.cookieService = cookieService;
        this.changeDetectorRef = changeDetectorRef;
        this.mode = 'view';
        this.isSubmitting = false;
        this.emailValidation = /^([A-Za-z0-9_\-\.]+)@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,3})$/;
        this.SUCCESS = 'Successfully updated user!';
        this.USER_UPDATE_FAILED = 'Failed to update user data.';
        this.UTILITY_WHITELIST = ['CONSOLIDATED_EDISON_COMPANY_OF_NEW_YORK_CONED'];
        this.isCommunityUser = false;
        this.userUpdateForm = new FormGroup({
            user_id: new FormControl(''),
            addresses: new FormArray([]),
            phones: new FormArray([]),
            email: new FormControl('', [Validators.required, Validators.pattern(this.emailValidation)]),
            timezone: new FormControl('America/New_York', Validators.required),
            locale: new FormControl('en_US', Validators.required),
            unit_system: new FormControl('IMPERIAL', Validators.required),
            home_application: new FormControl('', Validators.required),
            first_name: new FormControl('', Validators.required),
            last_name: new FormControl('', Validators.required),
            organization: new FormControl(''),
            title: new FormControl(''),
        });
        this.sections = [];
        this.logoutLink = {
            link: '',
            label: '',
            id: 'LOGOUT',
        };
        this.profileLink = {
            link: '',
            label: '',
            id: 'PROFILE',
        };
        this.myAccountLink = {
            link: '',
            label: '',
            id: 'MY_ACCOUNT',
        };
        this.customerLink = {
            link: '',
            label: '',
            id: 'CUSTOMER',
        };
        this.utilities = [];
        this.serviceAccounts = [];
        this.userData = {};
        this.metadata = {};
        this.primaryOrg = {};
        this.translate.get(`${namespace}GlobalNav.success`).subscribe((translation) => {
            this.SUCCESS = translation;
            this.USER_UPDATE_FAILED = this.translate.instant(`${namespace}GlobalNav.errors.update_user`);
        });
        this.globalNavService.userData$.subscribe((userData) => {
            if (userData) {
                this.userData = userData;
                this.primaryOrg = this.profileService.getPrimaryData(this.userData.profile.organizations) || {
                    display_label: '',
                };
            }
        });
        this.globalNavService.userRolesList$.subscribe((userRoles) => {
            if (userRoles) {
                if (userRoles.length > 0) {
                    this.isCommunityUser = userRoles.some((role) => role.business_role == 'COMMUNITY_USER');
                }
            }
        });
        this.globalNavService.metaData$.subscribe((metadata) => {
            if (metadata) {
                this.metadata = metadata;
            }
        });
    }
    get communityUser() {
        return this.isCommunityUser;
    }
    ngOnInit() {
        for (const section of this.sections) {
            if (section.children) {
                for (const item of section.children) {
                    if (item.id === 'LOGOUT') {
                        this.logoutLink = item;
                    }
                    if (item.id === 'PROFILE') {
                        this.profileLink = item || '';
                    }
                    if (item.id === 'CUSTOMER') {
                        this.customerLink = item || '';
                    }
                    if (item.id === 'MY_ACCOUNT') {
                        this.myAccountLink = item || '';
                    }
                }
            }
        }
        // Hardcode customer link if Atlas does not have it
        if (!this.customerLink.link || this.customerLink.link === '') {
            this.customerLink.link = this.getCustomerLink();
        }
        this.globalNavService.pendingUtilities$.subscribe((utilities) => {
            if (utilities) {
                this.finalizeUtilityLinks(utilities);
            }
        });
    }
    getCustomerLink() {
        const url = this.globalNavService.navUrl$.getValue();
        if (url.match('dev')) {
            return 'https://customers.dev-apps.enelx.net';
        }
        else if (url.match('preprd')) {
            return 'https://customers.preprd-apps.enelx.com';
        }
        return 'https://customers.apps.enelx.com';
    }
    getUserInitials() {
        if (this.userData && this.userData.profile && this.userData.profile.names) {
            const userName = this.userData.profile.names;
            return `${userName.first_name.charAt(0).toUpperCase()}${userName.last_system_name.charAt(0).toUpperCase()}`;
        }
        else {
            return '--';
        }
    }
    editMode($event) {
        $event.preventDefault();
        this.mode = 'edit';
    }
    viewMode($event) {
        $event.preventDefault();
        this.mode = 'view';
    }
    isViewMode() {
        return this.mode === 'view';
    }
    isEditMode() {
        return this.mode === 'edit';
    }
    async handleSubmit() {
        try {
            this.isSubmitting = true;
            const userData = this.userUpdateForm.getRawValue();
            const locale = userData.locale;
            userData.phones = userData.phones.map((phone) => {
                if (!phone.extension || phone.extension === '') {
                    delete phone.extension;
                }
                return phone;
            });
            if (userData.phones.filter((phone) => phone.phone_number !== '').length === 0) {
                delete userData.phones;
            }
            if (userData.addresses.filter((address) => address.address_1 !== '').length === 0) {
                delete userData.addresses;
            }
            await this.globalNavService.submitUserData(userData);
            this.globalNavService.refetchUser();
            this.globalAlertService.setSuccess(this.SUCCESS);
            this.isSubmitting = false;
            this.mode = 'view';
        }
        catch (err) {
            console.log('Could not update user ', err);
            this.globalAlertService.setError(this.USER_UPDATE_FAILED);
            this.isSubmitting = false;
        }
    }
    finalizeUtilityLinks(utils) {
        utils.forEach((utility) => {
            if (!utility.customerLink) {
                utility.customerLink = { ...this.customerLink };
                if (this.isConEd(utility.name)) {
                    utility.customerLink.link = `${this.getCustomerLink()}/authorizations/coned`;
                }
                else {
                    utility.customerLink.link = '';
                }
            }
        });
        this.utilities = utils;
        this.changeDetectorRef.markForCheck();
    }
    goTo(link) {
        window.location.href = link.link || '';
    }
    isConEd(utilityName) {
        return this.UTILITY_WHITELIST.includes(utilityName);
    }
    static { this.ɵfac = function ProfileComponent_Factory(t) { return new (t || ProfileComponent)(i0.ɵɵdirectiveInject(NAMESPACE_TOKEN), i0.ɵɵdirectiveInject(ProfileService), i0.ɵɵdirectiveInject(GlobalNavService), i0.ɵɵdirectiveInject(GlobalAlertService), i0.ɵɵdirectiveInject(i5.TranslateService), i0.ɵɵdirectiveInject(CookieService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProfileComponent, selectors: [["app-profile"]], inputs: { metadata: "metadata", sections: "sections" }, decls: 25, vars: 15, consts: [[1, "profile-wrapper"], [1, "profile-header"], [1, "circle"], [1, "name-org"], [1, "name", 3, "title"], [1, "org", 3, "title"], [1, "right-actions"], ["href", "#", "class", "button-link", 3, "title", "click", 4, "ngIf"], ["class", "icon-btn x-btn-primary", "aria-label", "Submit", "type", "submit", "data-automation", "submit", 3, "disabled", "title", "click", 4, "ngIf"], ["class", "btn-spinner", 4, "ngIf"], ["class", "profile-subheader", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "profile-button-wrapper"], ["data-automation", "my-account", "class", "x-btn-primary", 3, "click", 4, "ngIf"], ["data-automation", "my-profile", "class", "x-btn-primary", 3, "click", 4, "ngIf"], [1, "x-btn-secondary", 3, "click"], ["href", "#", 1, "button-link", 3, "title", "click"], ["color", "primary"], ["aria-label", "Submit", "type", "submit", "data-automation", "submit", 1, "icon-btn", "x-btn-primary", 3, "disabled", "title", "click"], [1, "btn-spinner"], ["diameter", "24"], [1, "profile-subheader"], [1, "user-text"], ["class", "x-btn-primary", "data-automation", "authorize", 3, "click", 4, "ngIf"], ["data-automation", "authorize", 1, "x-btn-primary", 3, "click"], ["updateForm", "ngForm"], [3, "userUpdateForm"], ["data-automation", "my-account", 1, "x-btn-primary", 3, "click"], ["data-automation", "my-profile", 1, "x-btn-primary", 3, "click"]], template: function ProfileComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 3)(5, "div", 4);
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 5);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 6);
            i0.ɵɵtemplate(10, ProfileComponent_a_10_Template, 4, 3, "a", 7);
            i0.ɵɵtemplate(11, ProfileComponent_a_11_Template, 4, 3, "a", 7);
            i0.ɵɵtemplate(12, ProfileComponent_button_12_Template, 4, 4, "button", 8);
            i0.ɵɵtemplate(13, ProfileComponent_div_13_Template, 2, 0, "div", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(14, ProfileComponent_div_14_Template, 9, 7, "div", 10);
            i0.ɵɵtemplate(15, ProfileComponent_app_view_profile_15_Template, 1, 0, "app-view-profile", 11);
            i0.ɵɵtemplate(16, ProfileComponent_form_16_Template, 3, 1, "form", 11);
            i0.ɵɵelementStart(17, "div", 12);
            i0.ɵɵtemplate(18, ProfileComponent_button_18_Template, 6, 3, "button", 13);
            i0.ɵɵtemplate(19, ProfileComponent_button_19_Template, 5, 1, "button", 14);
            i0.ɵɵelementStart(20, "button", 15);
            i0.ɵɵlistener("click", function ProfileComponent_Template_button_click_20_listener() { return ctx.goTo(ctx.logoutLink); });
            i0.ɵɵelementStart(21, "mat-icon");
            i0.ɵɵtext(22, "logout");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "span");
            i0.ɵɵtext(24);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.getUserInitials());
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("title", ctx.userData.profile.names.full_name);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.userData.profile.names.full_name, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("title", ctx.primaryOrg.display_label);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.primaryOrg.display_label, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.isViewMode());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isEditMode());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isEditMode() && !ctx.isSubmitting);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isEditMode() && ctx.isSubmitting);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.utilities);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isViewMode());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isEditMode());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.myAccountLink.link && ctx.communityUser);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.profileLink.link && !ctx.communityUser);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.logoutLink.label);
        } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i2.ɵNgNoValidate, i2.NgControlStatusGroup, i2.NgForm, i6.MatIcon, i9$1.MatProgressSpinner, EditProfileComponent, ViewProfileComponent, i5.TranslatePipe], styles: [".profile-header[_ngcontent-%COMP%]{display:flex;padding:30px 20px;position:sticky;top:0;z-index:4;background:#fff;border-bottom:solid 1px var(--row-highlight-hover)}.profile-header[_ngcontent-%COMP%]   .circle[_ngcontent-%COMP%]{width:50px;height:50px;line-height:52px}.profile-header[_ngcontent-%COMP%]   .name-org[_ngcontent-%COMP%]{margin-left:20px;padding-top:4px}.profile-header[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{font-weight:700;font-size:18px}.profile-header[_ngcontent-%COMP%]   .org[_ngcontent-%COMP%]{font-size:14px}.profile-header[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%], .profile-header[_ngcontent-%COMP%]   .org[_ngcontent-%COMP%]{white-space:nowrap;text-overflow:ellipsis;width:220px;overflow:hidden}.profile-header[_ngcontent-%COMP%]   .right-actions[_ngcontent-%COMP%]{right:20px;top:20px;line-height:30px;position:absolute}.profile-header[_ngcontent-%COMP%]   .right-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{position:relative;padding:0;margin:0;height:24px;width:24px;background-color:var(--primary-color)}.profile-header[_ngcontent-%COMP%]   .right-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:disabled{background:#777;border:none}.profile-header[_ngcontent-%COMP%]   .right-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{height:24px;width:24px;font-size:24px;color:#fff}.profile-header[_ngcontent-%COMP%]   .right-actions[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:block;height:30px}.profile-header[_ngcontent-%COMP%]   .right-actions[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{color:var(--primary-color);fill:var(--primary-color)}.profile-header[_ngcontent-%COMP%]   .right-actions[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:35px;transform:rotate(45deg);display:inline-block;padding:0;color:var(--primary-color)}.profile-subheader[_ngcontent-%COMP%]{display:flex;flex-flow:column wrap;justify-content:flex-start;align-items:flex-start;align-content:center;padding:30px 20px;position:sticky;top:0;background:#fff;border-bottom:solid 1px var(--row-highlight-hover)}.profile-subheader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{align-items:center;justify-content:flex-start;margin-bottom:15px;display:inline-flex;width:100%}.profile-subheader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{color:#f26092}.profile-subheader[_ngcontent-%COMP%]   .user-text[_ngcontent-%COMP%]{color:#999;padding-left:10px}.profile-button-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:center;width:100%;margin:30px 0 20px}.profile-button-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:4px 15px;line-height:28px;display:flex;justify-content:center;align-items:center;margin-right:10px;height:inherit}.profile-button-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding-left:5px}.profile-button-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:16px;width:16px;height:16px}.profile-button-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:first-of-type{margin-left:10px}.notice[_ngcontent-%COMP%]{text-align:center;padding:10px}", "input[_ngcontent-%COMP%]:focus, input[_ngcontent-%COMP%]:active, input[_ngcontent-%COMP%]:hover, select[_ngcontent-%COMP%]:focus, select[_ngcontent-%COMP%]:active, select[_ngcontent-%COMP%]:hover, textarea[_ngcontent-%COMP%]:focus, textarea[_ngcontent-%COMP%]:active, textarea[_ngcontent-%COMP%]:hover{border:none}.mat-mdc-form-field[_ngcontent-%COMP%]{width:100%}.mat-expansion-panel-header[_ngcontent-%COMP%]{background:var(--row-highlight);border-top:solid 1px var(--row-highlight-hover);border-bottom:solid 1px var(--row-highlight-hover);border-radius:0;padding-left:40px}.mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]:hover, .mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]:focus{background:var(--row-highlight)}.mat-expansion-panel-header-title[_ngcontent-%COMP%]{color:var(--primary-color);letter-spacing:.5px}.circle[_ngcontent-%COMP%]{background:var(--accent-color);color:#fff;border-radius:32px;height:30px;width:30px;text-align:center;line-height:32px;padding-left:1px;font-weight:700}  .mat-mdc-dialog-container{background-color:#fff!important}  .mat-expansion-panel-header{font-family:var(--fonts)!important}  .mat-expansion-panel-content{font-family:var(--fonts)!important}.mat-mdc-form-field-error[_ngcontent-%COMP%]{color:red}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfileComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'app-profile', template: "<div class=\"profile-wrapper\">\r\n    <div class=\"profile-header\">\r\n        <div class=\"circle\">{{ getUserInitials() }}</div>\r\n        <div class=\"name-org\">\r\n            <div class=\"name\" title=\"{{ userData.profile.names.full_name }}\">\r\n                {{ userData.profile.names.full_name }}\r\n            </div>\r\n            <div class=\"org\" title=\"{{ primaryOrg.display_label }}\">\r\n                {{ primaryOrg.display_label }}\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"right-actions\">\r\n            <a\r\n                href=\"#\"\r\n                *ngIf=\"isViewMode()\"\r\n                (click)=\"editMode($event)\"\r\n                class=\"button-link\"\r\n                title=\"{{ namespace + 'GlobalNav.buttons.edit_profile' | translate }}\"\r\n                ><mat-icon color=\"primary\">edit</mat-icon></a\r\n            >\r\n            <a\r\n                href=\"#\"\r\n                *ngIf=\"isEditMode()\"\r\n                (click)=\"viewMode($event)\"\r\n                class=\"button-link\"\r\n                title=\"{{ namespace + 'GlobalNav.buttons.cancel' | translate }}\"\r\n                ><span>&#43;</span></a\r\n            >\r\n            <button\r\n                class=\"icon-btn x-btn-primary\"\r\n                aria-label=\"Submit\"\r\n                (click)=\"handleSubmit()\"\r\n                [disabled]=\"userUpdateForm.pristine || !userUpdateForm.valid\"\r\n                type=\"submit\"\r\n                data-automation=\"submit\"\r\n                *ngIf=\"isEditMode() && !isSubmitting\"\r\n                title=\"{{ namespace + 'GlobalNav.buttons.submit' | translate }}\"\r\n            >\r\n                <mat-icon>done</mat-icon>\r\n            </button>\r\n            <div *ngIf=\"isEditMode() && isSubmitting\" class=\"btn-spinner\">\r\n                <mat-spinner diameter=\"24\"></mat-spinner>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"profile-subheader\" *ngFor=\"let utility of utilities\">\r\n        <div>\r\n          <mat-icon>warning_amber</mat-icon>\r\n          <span class=\"user-text\">{{ namespace + 'GlobalNav.profile.authorize_banner' | translate }} {{ utility.label | translate }}</span>\r\n        </div>\r\n        <button\r\n          *ngIf=\"utility.customerLink.link\"\r\n          class=\"x-btn-primary\"\r\n          (click)=\"goTo(utility.customerLink)\"\r\n          data-automation=\"authorize\">\r\n          <span>{{ namespace + 'GlobalNav.buttons.authorize' | translate }}</span>\r\n        </button>\r\n    </div>\r\n\r\n    <app-view-profile *ngIf=\"isViewMode()\"></app-view-profile>\r\n    <form *ngIf=\"isEditMode()\" #updateForm=\"ngForm\">\r\n        <app-edit-profile [userUpdateForm]=\"userUpdateForm\"></app-edit-profile>\r\n    </form>\r\n\r\n    <div class=\"profile-button-wrapper\">\r\n      <button *ngIf=\"myAccountLink.link && communityUser\"\r\n              data-automation=\"my-account\"\r\n              class=\"x-btn-primary\"\r\n              (click)=\"goTo(myAccountLink)\"\r\n      >\r\n        <mat-icon>person</mat-icon><span>{{ namespace + 'GlobalNav.buttons.my_account' | translate }}</span>\r\n      </button>\r\n      <button *ngIf=\"profileLink.link && !communityUser\"\r\n              data-automation=\"my-profile\"\r\n              class=\"x-btn-primary\"\r\n              (click)=\"goTo(profileLink)\"\r\n      >\r\n        <mat-icon>person</mat-icon><span>{{ profileLink.label }}</span>\r\n      </button>\r\n      <button class=\"x-btn-secondary\" (click)=\"goTo(logoutLink)\">\r\n        <mat-icon>logout</mat-icon><span>{{ logoutLink.label }}</span>\r\n      </button>\r\n    </div>\r\n</div>\r\n", styles: [".profile-header{display:flex;padding:30px 20px;position:sticky;top:0;z-index:4;background:#fff;border-bottom:solid 1px var(--row-highlight-hover)}.profile-header .circle{width:50px;height:50px;line-height:52px}.profile-header .name-org{margin-left:20px;padding-top:4px}.profile-header .name{font-weight:700;font-size:18px}.profile-header .org{font-size:14px}.profile-header .name,.profile-header .org{white-space:nowrap;text-overflow:ellipsis;width:220px;overflow:hidden}.profile-header .right-actions{right:20px;top:20px;line-height:30px;position:absolute}.profile-header .right-actions button{position:relative;padding:0;margin:0;height:24px;width:24px;background-color:var(--primary-color)}.profile-header .right-actions button:disabled{background:#777;border:none}.profile-header .right-actions button .mat-icon{height:24px;width:24px;font-size:24px;color:#fff}.profile-header .right-actions a{display:block;height:30px}.profile-header .right-actions a .mat-icon{color:var(--primary-color);fill:var(--primary-color)}.profile-header .right-actions a span{font-size:35px;transform:rotate(45deg);display:inline-block;padding:0;color:var(--primary-color)}.profile-subheader{display:flex;flex-flow:column wrap;justify-content:flex-start;align-items:flex-start;align-content:center;padding:30px 20px;position:sticky;top:0;background:#fff;border-bottom:solid 1px var(--row-highlight-hover)}.profile-subheader div{align-items:center;justify-content:flex-start;margin-bottom:15px;display:inline-flex;width:100%}.profile-subheader div .mat-icon{color:#f26092}.profile-subheader .user-text{color:#999;padding-left:10px}.profile-button-wrapper{display:flex;flex-direction:row;justify-content:center;width:100%;margin:30px 0 20px}.profile-button-wrapper button{padding:4px 15px;line-height:28px;display:flex;justify-content:center;align-items:center;margin-right:10px;height:inherit}.profile-button-wrapper button span{padding-left:5px}.profile-button-wrapper button .mat-icon{font-size:16px;width:16px;height:16px}.profile-button-wrapper button:first-of-type{margin-left:10px}.notice{text-align:center;padding:10px}\n", "input:focus,input:active,input:hover,select:focus,select:active,select:hover,textarea:focus,textarea:active,textarea:hover{border:none}.mat-mdc-form-field{width:100%}.mat-expansion-panel-header{background:var(--row-highlight);border-top:solid 1px var(--row-highlight-hover);border-bottom:solid 1px var(--row-highlight-hover);border-radius:0;padding-left:40px}.mat-expansion-panel-header.mat-expanded:hover,.mat-expansion-panel-header.mat-expanded:focus{background:var(--row-highlight)}.mat-expansion-panel-header-title{color:var(--primary-color);letter-spacing:.5px}.circle{background:var(--accent-color);color:#fff;border-radius:32px;height:30px;width:30px;text-align:center;line-height:32px;padding-left:1px;font-weight:700}::ng-deep .mat-mdc-dialog-container{background-color:#fff!important}::ng-deep .mat-expansion-panel-header{font-family:var(--fonts)!important}::ng-deep .mat-expansion-panel-content{font-family:var(--fonts)!important}.mat-mdc-form-field-error{color:red}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [NAMESPACE_TOKEN]
            }] }, { type: ProfileService }, { type: GlobalNavService }, { type: GlobalAlertService }, { type: i5.TranslateService }, { type: CookieService }, { type: i0.ChangeDetectorRef }]; }, { metadata: [{
            type: Input
        }], sections: [{
            type: Input
        }] }); })();

function GlobalAlertComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵelement(2, "span", 3);
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.messageClassName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.iconClassName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.message.message);
} }
class GlobalAlertComponent {
    constructor(service) {
        this.service = service;
        this.isErrorAlertVisible = false;
        this.service.messages.subscribe((message) => {
            this.displayAlert(message);
        });
    }
    displayAlert(message) {
        this.message = message;
        this.isErrorAlertVisible = true;
        setTimeout(() => {
            this.isErrorAlertVisible = false;
        }, 5000);
    }
    get isError() {
        return this.message.type === 'error';
    }
    get isSuccess() {
        return this.message.type === 'success';
    }
    get messageClassName() {
        return {
            'global-message': true,
            'alert': true,
            'alert-danger': this.isError,
            'alert-success': this.isSuccess,
        };
    }
    get iconClassName() {
        return {
            'icon': true,
            'fa': true,
            'fa-ban': this.isError,
            'fa-check-circle': this.isSuccess,
        };
    }
    static { this.ɵfac = function GlobalAlertComponent_Factory(t) { return new (t || GlobalAlertComponent)(i0.ɵɵdirectiveInject(GlobalAlertService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GlobalAlertComponent, selectors: [["app-global-alert"]], decls: 2, vars: 1, consts: [[1, "app-global-alert"], ["class", "global-message-wrapper", 4, "ngIf"], [1, "global-message-wrapper"], [3, "ngClass"], ["data-automation", "globalMessage"]], template: function GlobalAlertComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, GlobalAlertComponent_div_1_Template, 5, 3, "div", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isErrorAlertVisible);
        } }, dependencies: [i1$2.NgClass, i1$2.NgIf], styles: [".app-global-alert[_ngcontent-%COMP%]   .global-message-wrapper[_ngcontent-%COMP%]{position:absolute;z-index:999;width:100%;top:60px;left:0}.app-global-alert[_ngcontent-%COMP%]   .global-message-wrapper[_ngcontent-%COMP%]   .global-message[_ngcontent-%COMP%]{width:100%;display:flex;align-items:center;padding:20px}.app-global-alert[_ngcontent-%COMP%]   .global-message-wrapper[_ngcontent-%COMP%]   .global-message.alert-success[_ngcontent-%COMP%]{background:#e0f0e2}.app-global-alert[_ngcontent-%COMP%]   .global-message-wrapper[_ngcontent-%COMP%]   .global-message.alert-danger[_ngcontent-%COMP%]{background:#ffe3ed}.app-global-alert[_ngcontent-%COMP%]   .global-message-wrapper[_ngcontent-%COMP%]   .global-message[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:1.5em;margin-right:10px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalAlertComponent, [{
        type: Component,
        args: [{ selector: 'app-global-alert', template: "<div class=\"app-global-alert\">\r\n    <div *ngIf=\"isErrorAlertVisible\" class=\"global-message-wrapper\">\r\n        <div [ngClass]=\"messageClassName\">\r\n            <span [ngClass]=\"iconClassName\"></span>\r\n            <span data-automation=\"globalMessage\">{{ message.message }}</span>\r\n        </div>\r\n    </div>\r\n</div>\r\n", styles: [".app-global-alert .global-message-wrapper{position:absolute;z-index:999;width:100%;top:60px;left:0}.app-global-alert .global-message-wrapper .global-message{width:100%;display:flex;align-items:center;padding:20px}.app-global-alert .global-message-wrapper .global-message.alert-success{background:#e0f0e2}.app-global-alert .global-message-wrapper .global-message.alert-danger{background:#ffe3ed}.app-global-alert .global-message-wrapper .global-message .icon{font-size:1.5em;margin-right:10px}\n"] }]
    }], function () { return [{ type: GlobalAlertService }]; }, null); })();

const _c0 = ["sidenav"];
function GlobalNavComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "span", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 12);
    i0.ɵɵlistener("click", function GlobalNavComponent_div_4_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.openOrgSelector()); });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 13);
    i0.ɵɵlistener("click", function GlobalNavComponent_div_4_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.openOrgSelector()); });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.selectedOrgLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 3, ctx_r0.namespace + "GlobalNav.change"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 5, ctx_r0.namespace + "GlobalNav.change_org"));
} }
function GlobalNavComponent_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "menu-control", 17);
    i0.ɵɵlistener("click", function GlobalNavComponent_div_5_div_1_Template_menu_control_click_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.toggle("user")); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "menu-control", 18);
    i0.ɵɵlistener("click", function GlobalNavComponent_div_5_div_1_Template_menu_control_click_2_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.toggle("app")); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hint", ctx_r8.notificationHints)("label", ctx_r8.userLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", "menu");
} }
function GlobalNavComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, GlobalNavComponent_div_5_div_1_Template, 3, 3, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.hasData);
} }
function GlobalNavComponent_app_menu_10_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-menu", 19);
    i0.ɵɵlistener("select", function GlobalNavComponent_app_menu_10_Template_app_menu_select_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.onSelect($event)); })("close", function GlobalNavComponent_app_menu_10_Template_app_menu_close_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onClose()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("sections", ctx_r3.appsSections);
} }
function GlobalNavComponent_app_profile_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "app-profile", 20);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("sections", ctx_r4.userSections);
} }
const SSO_APPS = [{ id: 'ARCUS_SSO', path: '/login?token=' }];
class GlobalNavComponent {
    set contextList(spaces) {
        if (isNull(spaces)) {
            return;
        }
        if (spaces && spaces.length >= 1) {
            this.contextSelectorService.setPrimaryOrgId(this.primaryOrgId);
            this.contextSelectorService.setContextList(spaces);
            if (spaces.length > 1) {
                this.showOrgSelector = true;
            }
        }
    }
    set navUrl(navUrl) {
        if (navUrl) {
            this.globalNavService.setNavUrl(navUrl);
        }
    }
    set multiSelect(isMultiSelect) {
        if (isMultiSelect) {
            this.contextSelectorService.setMultiSelect(isMultiSelect);
        }
    }
    set maxSelections(maxSelections) {
        if (maxSelections) {
            this.contextSelectorService.setMaxSelections(maxSelections);
        }
    }
    set disabledNodeValues(values) {
        if (values) {
            this.contextSelectorService.setDisabledNodeValues(values);
        }
    }
    constructor(analytics, contextSelectorService, orgSelectorDialog, globalNavService, translate, cookieService, messagingService, namespace = '', _renderer2, _document) {
        this.analytics = analytics;
        this.contextSelectorService = contextSelectorService;
        this.orgSelectorDialog = orgSelectorDialog;
        this.globalNavService = globalNavService;
        this.translate = translate;
        this.cookieService = cookieService;
        this.messagingService = messagingService;
        this.namespace = namespace;
        this._renderer2 = _renderer2;
        this._document = _document;
        this.activeMenu = '';
        this.hasData = false;
        this.userLabel = '';
        this.notificationHints = 0;
        this.showOrgSelector = false;
        this.showZendesk = false;
        this.forceHideOrgSelector = false;
        this.selectedOrgLabel = 'Organizations';
        this.primaryOrgId = '';
        this.opened = false;
        this.user = {};
        this.USER_LOAD_FAILED = 'Failed to load user information';
        this.SERVICE_ACCOUNTS_FAILED = 'Failed to retrieve data for notifications, please refresh the page. If problem persists, please contact your Administrator.';
        this.sanitizedLocale = 'en_US';
        this.appLabel = '';
        this.appsSections = [];
        this.userSections = [];
        this.contextSelectorService.currentContext$.subscribe((contexts) => {
            if (contexts) {
                if (contexts.length === 1) {
                    this.selectedOrgLabel = contexts[0].label;
                }
                else if (contexts.length > 1) {
                    this.selectedOrgLabel = `${contexts[0].label} + ${contexts.length - 1}`;
                }
            }
        });
        this.contextSelectorService.forceHide$.subscribe((forceHide) => {
            this.forceHideOrgSelector = forceHide;
        });
        this.contextSelectorService.showContextSelector$.subscribe((show) => {
            this.showOrgSelector = show;
        });
        this.globalNavService.navUrl$.subscribe((navUrl) => {
            if (navUrl) {
                this.init();
            }
        });
        this.globalNavService.userData$.subscribe((user) => {
            if (user) {
                this.user = user;
                console.log('User Brand', this.user.brand);
                // ZENDESK INTEGRATION
                const zendesk = this.user.resources.find((resource) => resource.resource_name === 'ZENDESK');
                this.showZendesk = zendesk ? true : false;
                console.log('show zendesk: ', this.showZendesk);
                if (this.showZendesk) {
                    const script = this._renderer2.createElement('script');
                    script.id = 'ze-snippet';
                    script.src = `https://static.zdassets.com/ekr/snippet.js?key=a5b7fed9-b2d1-48d6-b7b9-7b3045133f5d`;
                    this._renderer2.appendChild(this._document.body, script);
                }
                this.globalNavService.getUserRoles(user.user_id);
                this.loadNav();
            }
        });
        this.globalNavService.serviceAccounts$.subscribe((accounts) => {
            if (accounts) {
                this.globalNavService.getPendingUtilities(accounts);
            }
        });
        this.globalNavService.pendingUtilities$.subscribe((utilities) => {
            if (utilities && utilities.length > 0) {
                this.addHint(utilities.length);
            }
            else {
                this.notificationHints = 0;
            }
        });
    }
    onSelect(item) {
        switch (item.id) {
            case 'LOGOUT': {
                this.analytics.pushEvent('Logout', {
                    'Target Application': item.label,
                });
                break;
            }
        }
    }
    onClose() {
        this.closeDrawer();
    }
    toggle(menu) {
        if (this.activeMenu === menu && this.opened) {
            this.closeDrawer();
        }
        else {
            this.openDrawer();
            this.activeMenu = menu;
            if (menu === 'app') {
                this.analytics.pushEvent('Expand Global Nav', { Menu: 'App Menu' });
            }
            else {
                this.analytics.pushEvent('Expand Global Nav', { Menu: 'User Menu' });
            }
        }
    }
    openDrawer() {
        if (!this.sidenav) {
            return;
        }
        this.sidenav.open();
    }
    closeDrawer() {
        if (!this.sidenav) {
            return;
        }
        this.sidenav.close();
    }
    addHint(amount) {
        if (amount) {
            this.notificationHints = amount;
        }
    }
    removeHint(amount) {
        if (amount || amount === 0) {
            this.notificationHints -= amount;
        }
        else {
            this.notificationHints -= 1;
        }
    }
    openOrgSelector() {
        this.orgSelectorDialog.open(ContextSelectorComponent, {
            position: { top: '30px' },
            width: '500px',
            id: 'tree-dialog'
        });
    }
    async init() {
        try {
            await this.globalNavService.getUser();
        }
        catch (err) {
            this.messagingService.setError(this.USER_LOAD_FAILED);
        }
        try {
            await this.globalNavService.getServiceAccounts();
        }
        catch (err) {
            this.messagingService.setError(this.SERVICE_ACCOUNTS_FAILED);
        }
    }
    async loadNav() {
        const locale = this.cookieService.getI18NLocale() || 'EN_US';
        this.sanitizedLocale = locale.replace('-', '_');
        const brand = this.cookieService.getI18NBrand() || 'ENELX';
        this.translate.use(`${locale}.${brand}`).subscribe(() => {
            this.translate.get(`${this.namespace}GlobalNav.errors.load_user`).subscribe((translation) => {
                this.USER_LOAD_FAILED = translation;
            });
            this.translate.get(`${this.namespace}GlobalNav.errors.service_accounts`).subscribe((translation) => {
                this.SERVICE_ACCOUNTS_FAILED = translation;
            });
        });
        try {
            const menuData = await this.globalNavService.getMenu(this.user.user_id, this.sanitizedLocale);
            if (isNull(menuData)) {
                return;
            }
            this.userLabel = menuData.user_menu_label;
            this.primaryOrgId = menuData.primary_org_id;
            this.appsSections = this.convert(menuData.app_menu);
            this.userSections = this.convert(menuData.user_menu);
            this.hasData = true;
            await this.globalNavService.getMetadata(this.user.user_id);
        }
        catch (err) {
            this.messagingService.setError(this.USER_LOAD_FAILED);
        }
    }
    convert(input) {
        return input.map(({ children }) => ({
            children: children.map(({ label, reference, item_id, reference_type }) => ({
                id: item_id,
                label,
                link: SSO_APPS.some(({ id }) => id === item_id) ? this.addToken(reference, item_id) : reference,
                external: reference_type === 'EXTERNAL_LINK',
            })),
        }));
    }
    addToken(reference, appId) {
        const app = SSO_APPS.find(({ id }) => id === appId) || { path: '/login?token=' };
        const enoc_session = this.cookieService.getCookie('enoc_session');
        return `${reference}${app.path}${enoc_session}`;
    }
    static { this.ɵfac = function GlobalNavComponent_Factory(t) { return new (t || GlobalNavComponent)(i0.ɵɵdirectiveInject(i1.AnalyticsService), i0.ɵɵdirectiveInject(ContextSelectorService), i0.ɵɵdirectiveInject(i3.MatDialog), i0.ɵɵdirectiveInject(GlobalNavService), i0.ɵɵdirectiveInject(i5.TranslateService), i0.ɵɵdirectiveInject(i1.CookieService), i0.ɵɵdirectiveInject(GlobalAlertService), i0.ɵɵdirectiveInject(NAMESPACE_TOKEN), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GlobalNavComponent, selectors: [["global-nav"]], viewQuery: function GlobalNavComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sidenav = _t.first);
        } }, inputs: { appLabel: "appLabel", contextList: "contextList", navUrl: "navUrl", multiSelect: "multiSelect", maxSelections: "maxSelections", disabledNodeValues: "disabledNodeValues" }, decls: 12, vars: 6, consts: [[1, "top-bar"], [1, "section-left"], [1, "logo"], ["class", "org-selector", 4, "ngIf"], ["class", "section-right", 4, "ngIf"], ["hasBackdrop", "true"], ["fixedInViewport", "true", "position", "end", "mode", "push", 3, "fixedTopGap", "opened", "openedChange"], ["sidenav", ""], [3, "sections", "select", "close", 4, "ngIf"], [3, "sections", 4, "ngIf"], [1, "org-selector"], ["data-automation-name", "org-context-value", 1, "context-org-label", "desktop"], ["data-automation-name", "org-context-button", 1, "org-change-button", "desktop", 3, "click"], ["data-automation-name", "org-context-button", 1, "org-change-button", "mobile", 3, "click"], [1, "section-right"], ["class", "controls", 4, "ngIf"], [1, "controls"], [3, "hint", "label", "click"], [3, "icon", "click"], [3, "sections", "select", "close"], [3, "sections"]], template: function GlobalNavComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "app-global-alert");
            i0.ɵɵelementStart(1, "div", 0)(2, "div", 1);
            i0.ɵɵelement(3, "span", 2);
            i0.ɵɵtemplate(4, GlobalNavComponent_div_4_Template, 9, 7, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, GlobalNavComponent_div_5_Template, 2, 1, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "mat-sidenav-container", 5);
            i0.ɵɵelement(7, "mat-sidenav-content");
            i0.ɵɵelementStart(8, "mat-sidenav", 6, 7);
            i0.ɵɵlistener("openedChange", function GlobalNavComponent_Template_mat_sidenav_openedChange_8_listener($event) { return ctx.opened = $event; });
            i0.ɵɵtemplate(10, GlobalNavComponent_app_menu_10_Template, 1, 1, "app-menu", 8);
            i0.ɵɵtemplate(11, GlobalNavComponent_app_profile_11_Template, 1, 1, "app-profile", 9);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.showOrgSelector && !ctx.forceHideOrgSelector);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.userSections && ctx.appsSections);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("fixedTopGap", 60);
            i0.ɵɵproperty("opened", ctx.opened);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.activeMenu === "app");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.activeMenu === "user");
        } }, dependencies: [i1$2.NgIf, i8$2.MatSidenav, i8$2.MatSidenavContainer, i8$2.MatSidenavContent, MenuControlComponent, MenuComponent, ProfileComponent, GlobalAlertComponent, i5.TranslatePipe], styles: ["@media (min-width: 769px){.mobile[_ngcontent-%COMP%]{display:none!important}}@media (max-width: 768px){.desktop[_ngcontent-%COMP%]{display:none!important}}[_nghost-%COMP%]{display:flex;flex-direction:column;font-size:14px;font-weight:400}[_nghost-%COMP%]   .top-bar[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;height:60px}[_nghost-%COMP%]   .top-bar[_ngcontent-%COMP%]   .section-left[_ngcontent-%COMP%]{flex:1 0 auto;display:flex}[_nghost-%COMP%]   .top-bar[_ngcontent-%COMP%]   .section-left[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{background-repeat:no-repeat;background-position-y:center}[_nghost-%COMP%]   .top-bar[_ngcontent-%COMP%]   .section-left[_ngcontent-%COMP%]   .org-selector[_ngcontent-%COMP%]   .org-change-button[_ngcontent-%COMP%]{display:inline-block;height:30px;line-height:29px;padding-right:20px;padding-left:20px;margin-left:15px;cursor:pointer}[_nghost-%COMP%]   .top-bar[_ngcontent-%COMP%]   .section-right[_ngcontent-%COMP%]   .controls[_ngcontent-%COMP%]{display:flex}[_nghost-%COMP%]   .expandable-bar[_ngcontent-%COMP%]{overflow:hidden}[_nghost-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]{z-index:998}[_nghost-%COMP%]   .mat-drawer[_ngcontent-%COMP%]{width:400px}[_nghost-%COMP%]     .mat-drawer-container-has-open .mat-drawer-backdrop{position:fixed;height:inherit;top:60px}@media screen and (max-width: 768px){[_nghost-%COMP%]   .mat-drawer[_ngcontent-%COMP%]{width:100%}}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalNavComponent, [{
        type: Component,
        args: [{ selector: 'global-nav', template: "<app-global-alert></app-global-alert>\r\n<div class=\"top-bar\">\r\n  <div class=\"section-left\">\r\n    <span class=\"logo\"></span>\r\n\r\n    <div *ngIf=\"showOrgSelector && !forceHideOrgSelector\" class=\"org-selector\">\r\n      <span class=\"context-org-label desktop\" data-automation-name=\"org-context-value\">{{ selectedOrgLabel }}</span>\r\n      <span class=\"org-change-button desktop\" data-automation-name=\"org-context-button\" (click)=\"openOrgSelector()\">{{ namespace + 'GlobalNav.change' | translate }}</span>\r\n      <span class=\"org-change-button mobile\" data-automation-name=\"org-context-button\" (click)=\"openOrgSelector()\">{{ namespace + 'GlobalNav.change_org' | translate }}</span>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"section-right\" *ngIf=\"userSections && appsSections\">\r\n    <div class=\"controls\" *ngIf=\"hasData\">\r\n      <menu-control (click)=\"toggle('user')\" [hint]=\"notificationHints\" [label]=\"userLabel\"></menu-control>\r\n      <menu-control (click)=\"toggle('app')\" [icon]=\"'menu'\"></menu-control>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n\r\n<mat-sidenav-container hasBackdrop=\"true\">\r\n  <mat-sidenav-content></mat-sidenav-content>\r\n  <mat-sidenav\r\n    #sidenav\r\n    fixedInViewport=\"true\"\r\n    fixedTopGap=\"{{60}}\"\r\n    position=\"end\"\r\n    mode=\"push\"\r\n    [(opened)]=\"opened\"\r\n  >\r\n    <app-menu *ngIf=\"activeMenu === 'app'\" [sections]=\"appsSections\" (select)=\"onSelect($event)\" (close)=\"onClose()\"></app-menu>\r\n    <app-profile *ngIf=\"activeMenu === 'user'\" [sections]=\"userSections\"></app-profile>\r\n  </mat-sidenav>\r\n</mat-sidenav-container>\r\n\r\n", styles: ["@media (min-width: 769px){.mobile{display:none!important}}@media (max-width: 768px){.desktop{display:none!important}}:host{display:flex;flex-direction:column;font-size:14px;font-weight:400}:host .top-bar{display:flex;justify-content:space-between;align-items:center;height:60px}:host .top-bar .section-left{flex:1 0 auto;display:flex}:host .top-bar .section-left .logo{background-repeat:no-repeat;background-position-y:center}:host .top-bar .section-left .org-selector .org-change-button{display:inline-block;height:30px;line-height:29px;padding-right:20px;padding-left:20px;margin-left:15px;cursor:pointer}:host .top-bar .section-right .controls{display:flex}:host .expandable-bar{overflow:hidden}:host mat-sidenav-container{z-index:998}:host .mat-drawer{width:400px}:host ::ng-deep .mat-drawer-container-has-open .mat-drawer-backdrop{position:fixed;height:inherit;top:60px}@media screen and (max-width: 768px){:host .mat-drawer{width:100%}}\n"] }]
    }], function () { return [{ type: i1.AnalyticsService }, { type: ContextSelectorService }, { type: i3.MatDialog }, { type: GlobalNavService }, { type: i5.TranslateService }, { type: i1.CookieService }, { type: GlobalAlertService }, { type: undefined, decorators: [{
                type: Inject,
                args: [NAMESPACE_TOKEN]
            }] }, { type: i0.Renderer2 }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { appLabel: [{
            type: Input
        }], contextList: [{
            type: Input
        }], navUrl: [{
            type: Input
        }], multiSelect: [{
            type: Input
        }], maxSelections: [{
            type: Input
        }], disabledNodeValues: [{
            type: Input
        }], sidenav: [{
            type: ViewChild,
            args: ['sidenav']
        }] }); })();

class FilterPipe {
    transform(value, searchText) {
        console.time(`Search`);
        if (searchText) {
            searchText = searchText.toLowerCase();
            return value.filter((el) => {
                const parentSearch = el.display_label.toLowerCase().indexOf(searchText) > -1;
                if (!parentSearch && el.children) {
                    return !!el.children.find((child) => {
                        return child.display_label.toLowerCase().indexOf(searchText) > -1;
                    });
                }
                return parentSearch;
            });
        }
        return value;
    }
    static { this.ɵfac = function FilterPipe_Factory(t) { return new (t || FilterPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "filter", type: FilterPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterPipe, [{
        type: Pipe,
        args: [{
                name: 'filter'
            }]
    }], null, null); })();

class GlobalNavModule {
    static forRoot(config) {
        return {
            ngModule: GlobalNavModule,
            providers: [{ provide: NAMESPACE_TOKEN, useValue: config.namespace }],
        };
    }
    static { this.ɵfac = function GlobalNavModule_Factory(t) { return new (t || GlobalNavModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: GlobalNavModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            CookieService$1,
            ProfileService,
            ApiService,
            GlobalAlertService,
            { provide: NAMESPACE_TOKEN, useValue: '' },
        ], imports: [CommonModule,
            FormsModule,
            HttpClientModule,
            FormsModule,
            ReactiveFormsModule,
            BrowserAnimationsModule,
            TranslateModule,
            MatDialogModule,
            MatIconModule,
            MatSidenavModule,
            MatExpansionModule,
            MatFormFieldModule,
            MatSelectModule,
            MatInputModule,
            MatProgressSpinnerModule,
            MatButtonModule,
            MatListModule,
            TreeModule,
            MatTooltipModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalNavModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    HttpClientModule,
                    FormsModule,
                    ReactiveFormsModule,
                    BrowserAnimationsModule,
                    TranslateModule,
                    MatDialogModule,
                    MatIconModule,
                    MatSidenavModule,
                    MatExpansionModule,
                    MatFormFieldModule,
                    MatSelectModule,
                    MatInputModule,
                    MatProgressSpinnerModule,
                    MatButtonModule,
                    MatListModule,
                    TreeModule,
                    MatTooltipModule,
                ],
                declarations: [
                    GlobalNavComponent,
                    MenuControlComponent,
                    MenuComponent,
                    ProfileComponent,
                    EditProfileComponent,
                    ViewProfileComponent,
                    ContextSelectorComponent,
                    FilterPipe,
                    PhoneNumberPipe,
                    GlobalAlertComponent
                ],
                exports: [GlobalNavComponent],
                providers: [
                    CookieService$1,
                    ProfileService,
                    ApiService,
                    GlobalAlertService,
                    { provide: NAMESPACE_TOKEN, useValue: '' },
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GlobalNavModule, { declarations: [GlobalNavComponent,
        MenuControlComponent,
        MenuComponent,
        ProfileComponent,
        EditProfileComponent,
        ViewProfileComponent,
        ContextSelectorComponent,
        FilterPipe,
        PhoneNumberPipe,
        GlobalAlertComponent], imports: [CommonModule,
        FormsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        TranslateModule,
        MatDialogModule,
        MatIconModule,
        MatSidenavModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        MatListModule,
        TreeModule,
        MatTooltipModule], exports: [GlobalNavComponent] }); })();

class AuthService {
    constructor(document) {
        this.document = document;
    }
    errorProc(error) {
        if (error.status === 401) {
            this.redirect(error);
        }
    }
    redirect(error) {
        console.warn('Unauthenticated user', error);
        const loginUrl = error.error.login_url;
        if (loginUrl) {
            console.warn('Redirecting to: ' + loginUrl);
            const returnURL = encodeURIComponent(this.document.location.href);
            this.document.location.href = loginUrl + '?goto=' + returnURL;
        }
        else {
            console.error('No redirect URL was provided from API endpoint!');
        }
    }
    static { this.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(i0.ɵɵinject(DOCUMENT)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AuthService, ContextSelectorService, GlobalAlertService, GlobalNavComponent, GlobalNavModule, GlobalNavService };
